const App = function () {

    const TYPE_PEDIDOS = 1;
    const TYPE_PRESUPUESTOS = 2;

    let __initRenewSession = function () {
        setInterval(function () {
            $.ajax({
                method: 'post',
                url   : HOST + '/renew-session'
            });
        }, (1000 * 60 * 15));
    };

    const __initFastClick = function () {
        if (typeof (window.FastClick) != 'undefined') {
            window.FastClick.attach(document.body);
        }
    };

    const __initGcvComisiones = function () {
        if (!$.fn.select2) {
            return;
        }

        const $periodos = $('.gcv-comisiones-periodos');
        $periodos.select2({
            allowClear: true,
            placeholder: 'Periodo/s',
            width: '100%'
        });

        const resizePeriodos = function () {
            $periodos.each(function () {
                const $select = $(this);
                const $container = $select.next('.select2-container');
                const $parent = $select.parent();
                const paddingLeft = parseFloat($parent.css('padding-left')) || 0;
                const paddingRight = parseFloat($parent.css('padding-right')) || 0;
                const width = $parent.innerWidth() - paddingLeft - paddingRight;

                if ($container.length && width > 0) {
                    $container.width(width);
                }
            });
        };

        resizePeriodos();
        $(window)
            .off('resize.gcvComisiones')
            .on('resize.gcvComisiones', resizePeriodos);
    };

    const __initInputs = function () {
        $('.dbr-material').find('input,textarea')
            .on('keyup', function () {
                $(this).parent().toggleClass('input--filled', !($(this).val() == ''))
            })
            .each(function (i, el) {
                $(el).parent().toggleClass('input--filled', !($(this).val() == ''))
            })
            .on('hide.uk.datepicker', function (e) {
                $(this).parent().toggleClass('input--filled', !($(this).val() == ''))
            })
            .each(function (i, el) {
                $(el).parent().toggleClass('input--filled', !($(this).val() == ''))
            });

        setTimeout(function () {
            $('input:-webkit-autofill').each(function (i, el) {
                $(el).parent().toggleClass('input--filled', true);
            });
        }, 100);

        // $("input[name='sfd']","#fSearchComentarios").off("change").on("change",function(){
        //     var fecha_hasta=$("input[name='sfh']","#fSearchComentarios").val();
        //     if(moment(fecha_hasta).isBefore($(this).val(),'day')){
        //         $("input[name='sfh']","#fSearchComentarios").val($(this).val());
        //     }
        // });
        // $("input[name='sfh']","#fSearchComentarios").off("change").on("change",function(){
        //     var fecha_desde=$("input[name='sfd']","#fSearchComentarios").val();
        //     if(moment(fecha_desde).isAfter($(this).val(),'day')){
        //         $("input[name='sfd']","#fSearchComentarios").val($(this).val());
        //     }
        // });

        $("input[name='sfd']").each(function () {
            $(this).off("change").on("change", function () {
                const fecha_hasta = $("input[name='sfh']").val();
                if (moment(fecha_hasta).isBefore($(this).val(), 'day')) {
                    $("input[name='sfh']").val($(this).val());
                }
            });
        });

        $("input[name='sfh']").each(function () {
            $(this).off("change").on("change", function () {
                const fecha_desde = $("input[name='sfd']").val();
                if (moment(fecha_desde).isAfter($(this).val(), 'day')) {
                    $("input[name='sfd']").val($(this).val());
                }
            });
        });

    };

    const __initValidation = function () {
        if (typeof ($.validator) != "undefined") {
            jQuery.validator.setDefaults({
                debug       : false,
                errorElement: 'em', //default input error message container
                errorClass  : 'uk-width-1-1 uk-text-small help-block error-block', // default input error message class
                focusInvalid: false, // do not focus the last invalid input
                //ignore         : "",
                errorPlacement: function (error, element) { // render error placement for each input type
                    $input_container = $(element).closest('.uk-input-container')
                    if ($input_container.length > 0) {
                        $element_container = $input_container;
                    } else {
                        $element_container = $(element).parent();
                    }
                    $element_container.append(error);
                },
                highlight     : function (element) { // hightlight error inputs
                    $input_container = $(element).closest('.uk-input-container')
                    if ($input_container.length > 0) {
                        $element_container = $input_container;
                    } else {
                        $element_container = $(element).parent();
                    }
                    $element_container.addClass('has-error'); // set error class to the control group
                    // if ($element_container.find('legend i').length == 0) {
                    // 	$element_container.find('legend').append(' <i class="uk-icon-angle-double-down"></i>');
                    // }
                    $(element).toggleClass('has-error', true);
                },
                unhighlight   : function (element) { // revert the change done by hightlight
                    $input_container = $(element).closest('.uk-input-container')
                    if ($input_container.length > 0) {
                        $element_container = $input_container;
                    } else {
                        $element_container = $(element).parent();
                    }
                    $element_container.removeClass('has-error'); // set error class to the control group
                    $element_container.find('legend i').remove();
                    $(element).toggleClass('has-error', false);
                },
                success       : function (label) {
                    label.closest('.uk-form-row').removeClass('has-error'); // set success class to the control group
                }
            });
        }
    };

    const __initDates = function () {
        moment.locale(LANG);
        $('*[data-time]:not([time-procesed])').each(function (i, el) {
            if (typeof $(this).data('time-format') != 'undefined') {
                switch ($(this).data('time-format')) {
                    case 'calendar':
                        $(this).html(moment($(this).data('time'), 'YYYY-MM-DD hh:mm:ss').calendar());

                        break;
                    case 'fromNow':
                        $(this).html(moment($(this).data('time'), 'YYYY-MM-DD hh:mm:ss').fromNow());

                        break;
                    default:
                        $(this).html(moment($(this).data('time'), 'YYYY-MM-DD hh:mm:ss').format($(this).data('time-format') || 'MMM D[,] YYYY'));

                        break;
                }
            } else {
                $(this).html(moment($(this).data('time'), 'YYYY-MM-DD hh:mm:ss').format($(this).data('time-format') || 'MMM D[,] YYYY'));
            }
            $(this).attr('time-procesed');
        });

        if ($.isFunction($.fn.datepicker)) {
            $.datepicker.regional['es'] = {
                closeText         : 'Cerrar',
                prevText          : 'Anterior',
                nextText          : 'Siguiente',
                currentText       : 'Hoy',
                monthNames        : [
                    'Enero',
                    'Febrero',
                    'Marzo',
                    'Abril',
                    'Mayo',
                    'Junio',
                    'Julio',
                    'Agosto',
                    'Septiembre',
                    'Octubre',
                    'Noviembre',
                    'Diciembre'
                ],
                monthNamesShort   : [
                    'Ene',
                    'Feb',
                    'Mar',
                    'Abr',
                    'May',
                    'Jun',
                    'Jul',
                    'Ago',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dic'
                ],
                dayNames          : [
                    'Domingo',
                    'Lunes',
                    'Martes',
                    'Miércoles',
                    'Jueves',
                    'Viernes',
                    'Sábado'
                ],
                dayNamesShort     : [
                    'Dom',
                    'Lun',
                    'Mar',
                    'Mié',
                    'Juv',
                    'Vie',
                    'Sáb'
                ],
                dayNamesMin       : [
                    'Do',
                    'Lu',
                    'Ma',
                    'Mi',
                    'Ju',
                    'Vi',
                    'Sá'
                ],
                weekHeader        : 'Sm',
                dateFormat        : 'dd/mm/yy',
                firstDay          : 1,
                isRTL             : false,
                showMonthAfterYear: false,
                yearSuffix        : '',
                // changeMonth       : true,
                // changeYear        : true
            };
            $.datepicker.setDefaults($.datepicker.regional['es']);

            $('input.datepicker').datepicker();
        }
    };

    const __errorCallback = function ($form, json) {
        const $form_send = $('#' + $form.attr('id') + '-send');
        $form_send.prop("disabled", false).toggleClass('form-sending', false).html($form_send.data('title'));
        Notificacion(json.msg || 'Ha ocurrido un error al realizar la acción solicitada. Por favor, inténtalo de nuevo más tarde.', 'danger');
        __unblockUI();
    };

    const __handleForm = function (formId, validationOpts, callback) {
        const $form = $("#" + formId),
            $form_send = $("#" + formId + "-send");

        const htmlButton = $form_send.html();

        validationRules = validationOpts.rules || {};
        validationMessages = validationOpts.messages || {};

        $form.validate({
            rules         : validationRules,
            messages      : validationMessages,
            submitHandler : function () {
                const successCallback = function (json) {
                    $form_send.prop("disabled", false).toggleClass('form-sending', false).html(htmlButton);

                    if ($.isFunction(callback)) {
                        callback.call(this, $form, json)
                    }
                    __unblockUI();
                };

                $form_send.prop("disabled", true).toggleClass('form-sending', true).html('Enviando...');
                __blockUI();
                $form.ajaxSubmit({
                    dataType: 'json',
                    success : successCallback,
                    error   : function () {
                        __errorCallback($form, []);
                    }
                });
            },
            invalidHandler: function (a, b, c) {
                Notificacion('Hay errores en el formulario. Revisa que los campos requeridos están cubiertos correctamente', 'warning');
            }
        });
        $form_send.click(function (e) {
            e.preventDefault();
            if ($form_send.hasClass('form-sending')) {
                return;
            }
            $form.submit();
        });

    };

    const __alert = function (opts, callback) {
        opts.title = opts.title ?? 'Atención';
        opts.icon = opts.icon ?? 'warning';
        const sa = Swal.fire({
            title            : opts.title,
            html             : opts.msg,
            icon             : opts.icon,
            confirmButtonText: 'Aceptar'
        }).then(function () {
            if (typeof (callback) == 'function') {
                callback.call(null);
            }
        });

        // var html = '<div id="alert" class="uk-modal" uk-modal="center: true">';
        // html += '<div class="uk-modal-dialog">';
        // html += '<button class="uk-modal-close-default uk-close uk-icon" type="button" uk-close=""></button>';
        // html += '<div class="uk-modal-header">';
        // html += '<h2 class="uk-modal-title">Información</h2>';
        // html += '</div>';
        // html += '<div class="uk-modal-body">';
        // html += msg;
        // html += '</div>';
        // html += '<div class="uk-modal-footer uk-text-right">';
        // html += '<button class="uk-button uk-button-primary" type="button" id="alert-button">Aceptar</button>';
        // html += '</div>';
        // html += '</div>';
        // html += '</div>';
        //
        //
        // $(html).appendTo('body');
        //
        // var modal = UIkit.modal("#alert");
        // var $modal = $("#alert");
        // modal.show();
        // $modal
        //     .on({
        //         'show.uk.modal': function () {
        //
        //         },
        //         'hide.uk.modal': function () {
        //             if (typeof (callback) == 'function') {
        //                 callback.call(null);
        //             }
        //             $modal.remove();
        //         }
        //     })
        //     .on('click', '#alert-button', function () {
        //         modal.hide();
        //     });
    };

    // var __confirm = function (msg, callback_ok, callback_ko) {
    const __confirm = function (opts) {
        opts.icon = opts.icon ?? 'warning';
        Swal.fire({
            title            : opts.title,
            text             : opts.msg,
            icon             : opts.icon,
            showCancelButton : true,
            cancelButtonText : 'Cancelar',
            confirmButtonText: 'Aceptar',
        }).then((result) => {
            if (result.isConfirmed) {
                if (typeof (opts.callback_ok) == 'function') {
                    opts.callback_ok.call(null);
                }
            } else {
                if (typeof (opts.callback_ko) == 'function') {
                    opts.callback_ko.call(null);
                }
            }
        });
        // var timestamp = new Date().getTime();
        //
        // var html = '<div id="confirm-' + timestamp + '" uk-modal>';
        // html += '<div class="uk-modal-dialog">';
        // html += '<button class="uk-modal-close-default" type="button" uk-close></button>';
        // html += '<div class="uk-modal-header">';
        // html += '<h2 class="uk-modal-title">Confirmación</h2>';
        // html += '</div>';
        // html += '<div class="uk-modal-body">' + msg + '</div>';
        // html += '<div class="uk-modal-footer">';
        // html += '<div class="uk-child-width-auto@s uk-grid-small uk-flex uk-flex-center" uk-grid>';
        // html += '<div><button class="uk-button ex-button-orange" type="button" id="confirm-button">Aceptar</button></div>';
        // html += '<div class="uk-flex uk-flex-middle"><button class="uk-button uk-button-text" type="button" id="cancel-button">Cancelar</button></div>';
        // html += '</div>';
        // html += '</div>';
        // html += '</div>';
        // html += '</div>';
        //
        // var respuesta = 'ko';
        //
        // $(html).appendTo('body');
        //
        // var modal = UIkit.modal('#confirm-' + timestamp + '');
        // var $modal = $('#confirm-' + timestamp + '');
        // modal.show();
        // $modal
        //     .on({
        //         'show.uk.modal': function () {
        //
        //         },
        //         'hide.uk.modal': function () {
        //             switch (respuesta) {
        //                 case 'ok':
        //                     if (typeof (callback_ok) == 'function') {
        //                         callback_ok.call(null);
        //                     }
        //                     // $modal.remove();
        //
        //                     break;
        //                 case 'ko':
        //                     if (typeof (callback_ko) == 'function') {
        //                         callback_ko.call(null);
        //                     }
        //                     // $modal.remove();
        //
        //                     break;
        //             }
        //         }
        //     })
        //     .on('click', '#confirm-button', function () {
        //         respuesta = 'ok';
        //         modal.hide();
        //     })
        //     .on('click', '#cancel-button', function () {
        //         respuesta = 'ko';
        //         modal.hide();
        //     });
    };

    const __initCookiePolicy = function () {
        if (Cookies.get('cookie_policy_accepted') != 'true') {
            const mode = "floating"; //mode: '' o 'floating'

            const cookies_msg = '<div id="cookies-msg" class="{{mode}}">\n\t<div>\n\t\t<div>\n\t\t\t<div class="uk-grid-small" uk-grid>\n\t\t\t\t<div class="uk-width-expand@m">\n\t\t\t\t\t<p>{{txt_cookies}}<a href="{{url_cookies_mas_info}}">{{txt_cookies_mas_info}}</a>.</p>\n\t\t\t\t</div>\n\t\t\t\t<div class="uk-width-auto@m uk-flex uk-flex-middle cookies-msg-actions">\n\t\t\t\t\t<div class="uk-width-1-1">\n\t\t\t\t\t\t<div class="uk-grid-small" uk-grid>\n\t\t\t\t\t\t\t<div class="uk-width-1-1 uk-width-expand@s uk-flex-middle@m">\n\t\t\t\t\t\t\t\t<div class="uk-width-1-1">\n\t\t\t\t\t\t\t\t\t<a href="#" class="uk-button uk-button-primary uk-width-1-1" id="cookies-msg-accept" title="{{txt_cookies_aceptar}}">{{txt_cookies_aceptar}}</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="uk-width-1-1 uk-width-auto@s uk-flex uk-flex-middle uk-flex-center">\n\t\t\t\t\t\t\t\t<div class="uk-width-1-1">\n\t\t\t\t\t\t\t\t\t<a href="#" id="cookies-msg-cancel" title="{{txt_cookies_cancelar}}"><span class="uk-hidden@s">{{txt_cookies_cancelar}}</span><span class="uk-visible@s">&#9587;</span></a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>';

            const $cookiePolicymessage = $(
                cookies_msg
                    .replace(/{{mode}}/gi, mode)
                    .replace(/{{txt_cookies}}/gi, 'Las cookies de este sitio se usan para personalizar el contenido y los anuncios para ofrecer funciones de medios sociales y para analizar el tráfico. Además, compartimos información sobre el uso que haga del sitio web con nuestros partners de medios sociales de publicidad y de análisis web. ')
                    .replace(/{{txt_cookies_mas_info}}/gi, 'Más información')
                    .replace(/{{url_cookies_mas_info}}/gi, HOST + '/politica-cookies')
                    .replace(/{{txt_cookies_aceptar}}/gi, 'Aceptar')
                    .replace(/{{txt_cookies_cancelar}}/gi, 'Cerrar')
            );


            $cookiePolicymessage
                .on('click', '#cookies-msg-accept', function (e) {
                    e.preventDefault();

                    Cookies.set('cookie_policy_accepted', 'true', {
                        expires: 365,
                        path   : (location.hostname.match(/192/i) || location.hostname.match(/205\./i) ? '/' + location.href.replace(location.protocol + '//' + location.hostname, '').substr(1).split('/')[0] + '/' : '/')
                    });

                    $cookiePolicymessage.fadeOut('normal', function () {
                        $(this).remove();
                    });
                })
                .on('click', '#cookies-msg-cancel', function (e) {
                    e.preventDefault();

                    $cookiePolicymessage.fadeOut('normal', function () {
                        $(this).remove();
                    });
                });

            $cookiePolicymessage.appendTo('body');

            setTimeout(function () {
                $cookiePolicymessage.toggleClass('shown', true);
            }, 1000);

        }
    };

    const __initLogin = function () {

        if ($("#page-index").length > 0) {
            let $form = $("form#fLogin");
            $form.validate({
                rules        : {
                    "username": {
                        required: true
                    },
                    "password": {
                        required: true
                    }
                },
                submitHandler: function (form) {
                    $(form).ajaxSubmit({
                        dataType  : "json",
                        error     : App.handleError,
                        beforeSend: function () {
                            __blockUI({
                                msg: '<i uk-spinner="ratio: 0.8"></i> Conectándose a la intranet...'
                            });
                            $(".msgError").fadeOut();
                        },
                        complete  : function () {
                            // __unblockUI();
                        },
                        success   : function (json) {
                            if (json.success) {
                                location.href = HOST + (json.lastUri ?? "/dashboard");
                            } else {
                                $("#msg-response").html('<i uk-icon="warning"></i> ' + json.msg).fadeIn();
                                __unblockUI();
                            }
                        }
                    })
                }
            });

            $("#btnLogin").off().on('click', function (e) {
                e.preventDefault();
                $form.submit();
            });
            $("#password, #username").on('keypress', function (e) {
                if (e.keyCode == 13) {
                    $form.submit();
                }
            });
            if ($("input[name='username']", $form).val() != "" && $("input[name='password']", $form).val() != "") {
                const urlParams = new URLSearchParams(window.location.search);
                const logout = urlParams.get("logout");
                if (typeof logout == 'undefined' || logout !== "1") {
                    $form.submit();
                }
            }
        }
    };

    let __blockUI = function (options) {

        let target = "body";
        let clase = "";
        let msg = '<i uk-spinner="ratio: 0.8"></i> Enviando datos...'

        if (typeof options == "object") {
            if (typeof options.target != 'undefined') target = options.target;
            if (typeof options.clase != 'undefined') clase = options.clase;
            if (typeof options.msg != 'undefined') msg = options.msg;
        }

        let html = '' +
            '<div class="blockUI blockOverlay" style="display: none"></div>' +
            '<div class="blockUI blockMsg ' + clase + '">' +
            msg +
            '</div>';

        $(target).append(html);
        $("div.blockUI.blockOverlay").fadeIn();
    };

    let __unblockUI = function (target) {
        if (typeof target == "undefined") target = "body";
        $("div.blockUI", $(target)).fadeOut(function () {
            $(this).remove();
        });
    };

    let __initProductos = function () {
        if ($("#page-productos").length > 0 || $("#page-material-promocional").length > 0 || $("#page-favoritos").length > 0 || $("#page-comparador").length > 0) {
            let $btnSearch = $("#btnSearch");
            let $formSearch = $("#fSearch");
            let HandleBusqueda = function () {
                $btnSearch.off().on("click", function (e) {
                    e.preventDefault();
                    $formSearch.submit();
                });
            };
            const handleCheckValuesGroup = function (id_filtro, id_group) {
                const $values = $(".filter-group-value[data-id=" + id_group + "]", "#block-filter-" + id_filtro);
                let checked_all = true;
                let checked_some = false;
                $values.each(function (index) {
                    if ($(this).prop("checked") == false) {
                        checked_all = false;
                    } else {
                        checked_some = true;
                    }
                });
                $("#block-filter-" + id_filtro + " .filter-group[data-id='" + id_group + "']").prop("checked", checked_all);
                if (!checked_all && checked_some) {
                    $("#block-filter-" + id_filtro + " div.div-filter-group[data-id='" + id_group + "']").show();
                }
            };

            const handleGroups = function (id_filtro) {

                $(".btn-desplegable-grupo").off('click').on('click', function (e) {
                    const id_group = $(this).data("id");
                    const $table_group = $(".div-filter-group[data-id=" + id_group + "]");
                    if (!$table_group.is(":visible")) {
                        $table_group.show();
                    } else {
                        $table_group.hide();
                    }
                });

                $(".filter-group").off('change').on('change', function (e) {
                    const id_group = $(this).data("id");
                    const checked = $(this).is(':checked');
                    $(".filter-group-value[data-id=" + id_group + "]").prop("checked", checked);
                });

                //Si todos los elementos de un grupo están checkeados checkear el padre
                $(".filter-group-value", "#block-filter-" + id_filtro).off('change').on('change', function (e) {
                    const id_group = $(this).data("id");
                    if (id_group > 0) {
                        handleCheckValuesGroup(id_filtro, id_group);
                    }
                });

                $(".filter-group").each(function (index) {
                    const id_group = $(this).data("id");
                    if (id_group > 0) {
                        handleCheckValuesGroup(id_filtro, id_group);
                    }
                });
            };

            let HandleFormFilters = function () {

                const generateHtmlFilter = function (filtros) {
                    let html = '<fieldset class="uk-fieldset">';
                    for (const filtro of filtros) {
                        if (typeof filtro.groupId != 'undefined') {
                            html += '<label class="uk-clearfix">' +
                                '<input type="checkbox" class="uk-checkbox filter-group" data-id="' + filtro.groupId + '" name="group_' + filtro.groupId + '" value="' + filtro.groupId + '" ' + filtro.checked + '/>' + filtro.group +
                                ' <strong>[' + filtro.numProducts + ']</strong>' +
                                '<a href="javascript:;" class="btn-desplegable-grupo uk-float-right" data-id="' + filtro.groupId + '"> <span uk-icon="icon: chevron-down"></span></a>' +
                                '</label>' +
                                '';
                            html += '<div class="div-filter-group" data-id="' + filtro.groupId + '"  style="display:none;">';
                            $.each(filtro.values, function (index, groupValue) {
                                html += '<label>' +
                                    '<input type="checkbox" class="uk-checkbox filter-group-value" data-id="' + filtro.groupId + '" name="fl' + filtro.id_filtro + '[]" value="' + groupValue.value + '" ' + groupValue.checked + '/> ' + groupValue.value +
                                    ' <strong>[' + groupValue.numProducts + ']</strong>' +
                                    '</label>';
                            });
                            html += '</div>';
                        } else {
                            html += '<label>' +
                                '<input class="uk-checkbox" type="checkbox" name="fl' + filtro.id_filtro + '[]" value="' + filtro.valor + '" ' + filtro.checked + '/>' +
                                '' + filtro.valor + ' <strong>[' + filtro.num_productos + ']</strong>' +
                                '</label>';
                        }
                    }
                    html += '</fieldset>';

                    return html;
                }

                let $form = $("form[name='fFilters']");
                let $btn = $(".btnFiltersSearch");

                let filters = [];
                if ($("input[name='sf']").val() != '') {

                    $("[data-get-filtro]", $form.eq(0)).each(function () {
                        filters.push({
                            id        : $(this).data("id-filtro"),
                            selected  : $(this).data("selected"),
                            disponible: $(this).data("disponible"),
                        })
                    });
                    $.ajax({
                        type    : 'POST',
                        url     : HOST + '/get-filters-values',
                        data    : {
                            filters   : JSON.stringify(filters),
                            selected  : $("input[name='selectedFilters']").val(),
                            disponible: $("input[name='d']").val()
                        },
                        dataType: 'json',
                        success : function (json) {
                            if (json.success) {
                                $.each(json.data, function (index, value) {
                                    if (value.length === undefined) {
                                        value = [value];
                                    }
                                    let $block = $("#block-filter-" + value.id);
                                    const html = generateHtmlFilter(value);

                                    console.log(value[0]);
                                    $(".uk-accordion-content", $("[data-id-filtro='" + value[0].id_filtro + "']").parent()).html(html);
                                    $("[data-id-filtro='" + value[0].id_filtro + "']").fadeIn();

                                    $(".btn-desplegable-grupo", $block).each(function (index) {
                                        handleCheckValuesGroup(value.id, $(this).data("id"));
                                    });
                                    handleGroups(value.id);
                                })
                            }
                        }
                    });
                }

                $btn.off().on("click", function (e) {
                    e.preventDefault();
                    $(this).html('<div uk-spinner></div> Buscando...').attr("disabled", true);
                    let $this = $(this);
                    $.each($form, function (i, elem) {
                        if ($(elem).hasClass($this.data("type"))) {
                            $form = $(elem);
                        }
                    })
                    $("input[name='w']", $form).val($("input#inputBusquedaRapida").val());
                    $form.submit();
                });
            };

            let HandleOrder = function () {
                $("select[name='or'], select[name='ot']").off().on("change", function () {
                    let name = $(this).attr("name");
                    $("input[name='" + name + "']", $formSearch).val($(this).val());
                    $btnSearch.trigger('click');
                });
            };

            let handle_eficiencia_energetica = function () {
                let $productos = $(".ex-producto");
                if ($productos.length > 0) {
                    let codigos_ean = "";
                    $productos.each(function (index, elem) {
                        codigos_ean += $(elem).data("ean") + ",";
                    });
                    codigos_ean = codigos_ean.substring(0, codigos_ean.length - 1);

                    if (codigos_ean !== "") {

                        $.ajax({
                            type    : "GET",
                            url     : HOST + "/productos/get-etiqueta-energetica-todos/" + codigos_ean,
                            dataType: "json",
                            success : function (json) {
                                if (json.success) {
                                    $.each(json.imagen_efic, function (codigo_ean, imagen_efic) {
                                        $("span.eficiencia-energetica", $(".ex-producto[data-ean='" + codigo_ean + "']")).html(imagen_efic);
                                    });
                                    // contenedor.html(json.content);
                                    $(".spinner").fadeOut(function () {
                                        $(".db").fadeIn()
                                    });
                                }
                            }
                        });
                    }
                }
            }

            HandleEventsProducts();
            HandleBusqueda();
            HandleOrder();
            HandleFormFilters();
            __handlePreciosStock();
            handle_eficiencia_energetica();
        }
    };

    let __initComparador = function () {
        if ($('#page-comparador').length > 0) {
            __handlePreciosStock();
        }
    };

    let __handlePreciosStock = function () {
        let $productos = $(".ex-producto");
        if ($productos.length > 0) {
            let codigos = "";
            $productos.each(function (index, elem) {
                codigos += $(elem).data("codigo") + ",";
            });
            codigos = codigos.substring(0, codigos.length - 1);
            //Hacemos llamada Ajax para obtener los precios/stocks
            if (codigos !== "") {
                $.ajax({
                    type    : "GET",
                    url     : HOST + "/productos/precio-stock/" + codigos,
                    dataType: "json",
                    success : function (json, status, xhr) {
                        if (json.error == 'session_out') {
                            location.href = HOST;
                        } else {
                            $.each(json.stock, function (codigo, stock) {
                                $.each(stock, (indice, stock) => {
                                    $("span.producto-stock[data-id-almacen='" + indice + "']", $(".ex-producto[data-codigo='" + codigo + "']")).html(stock);
                                });
                            });

                            // Ticket #17281
                            $.each(json.stock_fabricante, function (codigo, stock_fabricante) {
                                let diaIni, mesIni, anhoIni, diaFin, mesFin, anhoFin;
                                let fecha;

                                if (json.fecha_ini_disponibilidad[codigo] != "00000000"
                                    && json.fecha_fin_disponibilidad[codigo] != "00000000") {
                                    fecha = json.fecha_ini_disponibilidad[codigo];
                                    [anhoIni, mesIni, diaIni] = [fecha.slice(0, 4), fecha.slice(4, 6), fecha.slice(6, 8)];
                                    fecha = json.fecha_fin_disponibilidad[codigo];
                                    [anhoFin, mesFin, diaFin] = [fecha.slice(0, 4), fecha.slice(4, 6), fecha.slice(6, 8)];
                                }

                                if (json.stock_fabricante[codigo] != 0
                                    && json.fecha_ini_disponibilidad[codigo] == "00000000"
                                    && json.fecha_fin_disponibilidad[codigo] == "00000000") {
                                    $("span.producto-stock-fabricante", $(".ex-producto[data-codigo='" + codigo + "']")).html(stock_fabricante);
                                    $(".stock-fabricante", $(".ex-producto[data-codigo='" + codigo + "']")).show();
                                } else if (json.stock_fabricante[codigo] == 0 && json.fecha_ini_disponibilidad[codigo] == json.fecha_fin_disponibilidad[codigo] && json.fecha_ini_disponibilidad[codigo] != "00000000"
                                    && json.fecha_fin_disponibilidad[codigo] != "00000000") {
                                    $("span.producto-stock-fabricante", $(".ex-producto[data-codigo='" + codigo + "']")).html(`${diaIni}/${mesIni}/${anhoIni}`);
                                    $(".stock-fabricante", $(".ex-producto[data-codigo='" + codigo + "']")).show();
                                } else if (json.stock_fabricante[codigo] == 0
                                    && json.fecha_ini_disponibilidad[codigo] != "00000000"
                                    && json.fecha_fin_disponibilidad[codigo] != "00000000") {
                                    $("span.producto-stock-fabricante", $(".ex-producto[data-codigo='" + codigo + "']")).html(`${diaIni}/${mesIni}/${anhoIni} al ${diaFin}/${mesFin}/${anhoFin}`);
                                    $(".stock-fabricante", $(".ex-producto[data-codigo='" + codigo + "']")).show();
                                } else if (json.stock_fabricante[codigo] != 0
                                    && json.fecha_ini_disponibilidad[codigo] != "00000000"
                                    && json.fecha_fin_disponibilidad[codigo] != "00000000") {
                                    $("span.producto-stock-fabricante", $(".ex-producto[data-codigo='" + codigo + "']")).html(`${stock_fabricante}`);
                                    $(".stock-fabricante", $(".ex-producto[data-codigo='" + codigo + "']")).show();
                                }
                            });
                            // Fin ticket #17281
                            $.each(json.precio_neto_formatted, function (codigo, precio_formatted) {
                                $("span.producto-neto", $(".ex-producto[data-codigo='" + codigo + "']")).html(precio_formatted);
                            });

                            $.each(json.precio_tarifa_formatted, function (codigo, precio_formatted) {
                                $("span.producto-tarifa", $(".ex-producto[data-codigo='" + codigo + "']")).html(precio_formatted);
                                // Ticket #16124
                                $precio_pvr = $("span.producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).data("pvr");
                                $precio_pvr_formatted = number_format($precio_pvr, 2, ",", ".") + '&euro;';
                                if (json.permiso_pvr == Globals.PERMISO_PVR) {
                                    //En este caso no habría que hacer nada ya que el precio ya esta puesto (el dato sale de BD).
                                } else if (json.permiso_pvr == Globals.PERMISO_PVR_PVT_MAS_ALTO) {
                                    if (json.precio_tarifa[codigo] > $precio_pvr) {
                                        $("strong.label-producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html("PVT:");
                                        $("span.producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html(precio_formatted);
                                    } else if (json.precio_tarifa[codigo] <= $precio_pvr) {
                                        $("strong.label-producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html("PVR:");
                                        $("span.producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html($precio_pvr_formatted);
                                    }
                                } else if (json.permiso_pvr == Globals.PERMISO_PVR_PVT_PREVA_PVT) {
                                    if (json.precio_tarifa[codigo] > 0) {
                                        $("strong.label-producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html("PVT:");
                                        $("span.producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html(precio_formatted);
                                    } else {
                                        $("strong.label-producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html("PVR:");
                                        $("span.producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html($precio_pvr_formatted);
                                    }
                                } else if (json.permiso_pvr == Globals.PERMISO_PVR_PVT_PREVA_PVR) {
                                    if ($precio_pvr > 0) {
                                        $("strong.label-producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html("PVR:");
                                        $("span.producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html($precio_pvr_formatted);
                                    } else {
                                        $("strong.label-producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html("PVT:");
                                        $("span.producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html(precio_formatted);
                                    }
                                }
                                // Fin ticket #16124

                            });
                            $.each(json.margen_beneficio, function (codigo, margen) {
                                $("span.producto-beneficio", $(".ex-producto[data-codigo='" + codigo + "']")).html(number_format(margen, 2, ",", ".") + "%");
                                $("span.producto-beneficio-camuflado", $(".ex-producto[data-codigo='" + codigo + "']")).html(number_format(margen, 2, "", ""));
                            });
                            $.each(json.descuento, function (codigo, descuento) {
                                if (descuento > 0) {
                                    $("label.descuento", $(".ex-producto[data-codigo='" + codigo + "']")).html("-" + descuento + "%").fadeIn();
                                    $("label.promo", $(".ex-producto[data-codigo='" + codigo + "']")).attr("uk-tooltip", "title: Descuento Promoción")
                                }
                            });
                            $.each(json.precio_descuento_formatted, function (codigo, precio_descuento_formatted) {
                                if (precio_descuento_formatted !== "") {
                                    $("span.producto-neto", $(".ex-producto[data-codigo='" + codigo + "']")).addClass("ex-text-line-trough uk-text-muted")
                                    $("span.producto-precio-descuento", $(".ex-producto[data-codigo='" + codigo + "']")).html(precio_descuento_formatted).fadeIn();
                                }
                            });
                            $.each(json.precio_tarifa_descuento_formatted, function (codigo, precio_tarifa_descuento_formatted) {
                                $precio_pvr = $("span.producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).data("pvr");

                                if (precio_tarifa_descuento_formatted !== "") {
                                    $("span.producto-tarifa", $(".ex-producto[data-codigo='" + codigo + "']")).addClass("ex-text-line-trough uk-text-muted")
                                    $("span.producto-tarifa-descuento", $(".ex-producto[data-codigo='" + codigo + "']")).html(precio_tarifa_descuento_formatted).fadeIn();
                                    // Ticket #16124
                                    if (json.precio_tarifa[codigo] > $precio_pvr && json.permiso_pvr == Globals.PERMISO_PVR_PVT_MAS_ALTO) { // EN caso de que el PVR sea más alto que el PVT no hacemos ningún cambio en la etiqueta
                                        $("span.producto-tarifa-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).addClass("ex-text-line-trough uk-text-muted")
                                    }
                                    $("span.producto-tarifa-descuento-pvt-extra", $(".ex-producto[data-codigo='" + codigo + "']")).html(precio_tarifa_descuento_formatted).fadeIn();
                                    // Fin ticket #16124
                                }
                            });
                            $.each(json.tipo, function (codigo, tipo) {
                                if (tipo.toLowerCase() === Globals.TIPO_PRODUCTO_PROMOCION.toLowerCase()) {
                                    $("label.promo", $(".ex-producto[data-codigo='" + codigo + "']")).fadeIn();
                                }
                            });
                            $(".spinner").fadeOut(function () {
                                $(".db").fadeIn()
                            });
                        }
                    },
                    error   : function () {

                    }
                });
            }
        }
    }

    let __initProducto = function () {
        let $productoItem = $("#producto-item");
        if ($productoItem.length > 0) {
            let codigo = $productoItem.data("codigo");

            let HandleFichaIcecat = function () {
                $(document).on('click', '.trigger-ficha-icecat', function (e) {
                    e.preventDefault();
                    $('#ficha-icecat-content').html('<iframe src="' + $(this).data('url') + '" frameborder="0" width="100%" height="550"></iframe>')
                    const modal = UIkit.modal("#ficha-icecat");
                    modal.show();
                });
                $(document).on('click', '.btn-notif-icecat', function (e) {
                    e.preventDefault();
                    const modal = UIkit.modal("#modalError", {stack: true});
                    modal.show();
                    setTimeout(function () {
                        $("button.btnCancel", $("#modalError")).off("click").on("click", function (e) {
                            e.preventDefault();
                            $(".uk-close", $("#modalError")).trigger("click");
                        });

                        $("button.btnNotifica", $("#modalError")).off("click").on("click", function (e) {
                            e.preventDefault();
                            $("#formNotificacion").submit();
                        });
                        validaFormErrorIcecat();
                    }, 100);
                });
            }

            let validaFormErrorIcecat = function () {
                let $form = $("#formNotificacion");
                $form.validate({
                    rules        : {
                        descripcion: {
                            required: true
                        }
                    },
                    messages     : {
                        descripcion: {
                            required: "Debe indicar el error detectado"
                        }
                    },
                    submitHandler: function (form) {
                        $(form).ajaxSubmit({
                            dataType  : "json",
                            beforeSend: function (data) {
                                $("button.btnNotifica", $("#modalError")).addClass("disabled").attr("disabled", true).text("Enviando...");
                            },
                            success   : function (json) {
                                $("button.btnNotifica", $("#modalError")).removeClass("disabled").attr("disabled", false).text("Notificar");
                                let msg = "";
                                let status = "";
                                if (json.success) {
                                    msg = "Se ha notificado correctamente del error.";
                                    status = "success";
                                    $(".uk-close", $("#modalError")).trigger("click");
                                    $("textarea[name='descripcion']", $("#modalError")).val("");
                                } else {
                                    msg = "Ha ocurrido un error a la hora de notificar del error.";
                                    status = "danger";
                                }
                                Notificacion(msg, status);
                            }
                        });
                    }
                });
            };

            let HandlePreciosStocks = function (codigo) {
                let $stockAlmacen = $(".stock-almacen");
                let $precioNeto = $("#precio-neto");
                let $precioPvt = $("#precio-pvt");
                // Ticket #16124
                let $labelPrecioPvtPermisoExtra = $("#label-precio-pvt-permiso-extra");
                let $precioPvtPermisoExtra = $("#precio-pvt-permiso-extra");
                // Fin ticket #16124
                let $descuento = $("#descuento");
                let $precioDescuento = $("#precio-descuento");
                let $precioTarifaDescuento = $("#precio-tarifa-descuento");
                // Ticket #16124
                let $precioTarifaDescuentoPermisoExtra = $("#precio-tarifa-descuento-permiso-extra");
                // Fin ticket #16124
                let $margenBeneficio = $("#margen-beneficio");
                let $margenBeneficioCamuflado = $("#margen-beneficio-camuflado");
                let $promo = $("#promo");
                //Cargamos el precio recomendado desde el tpl para no tener que volver a hacer la consulta, ya que solo lo tenemos en bd
                let $precio_pvr = $precioPvtPermisoExtra.data("pvr");
                let $precio_pvr_formatted = number_format($precio_pvr, 2, ",", ".") + '&euro;'
                // Ticket #17281
                let $stockFabricante = $("#stock-fabricante");
                let $fechaDisp = $("#fecha-disp");
                // Fin ticket #17281
                $.ajax({
                    type    : "GET",
                    url     : HOST + "/productos/precio-stock/" + codigo,
                    dataType: "json",
                    success : function (json, status, xhr) {

                        if (json.error == 'session_out') {
                            location.href = HOST;
                        } else {
                            $.each(json.stock, function (codigo, stock) {
                                $.each(stock, (id_almacen, stock) => {
                                    $('.stock-almacen[data-id-almacen="' + id_almacen + '"]').html(stock)
                                });
                            });

                            // Ticket #17281
                            let diaIni, mesIni, anhoIni, diaFin, mesFin, anhoFin;
                            let fecha;

                            if (json.fecha_ini_disponibilidad[codigo] != "00000000"
                                && json.fecha_fin_disponibilidad[codigo] != "00000000") {
                                fecha = json.fecha_ini_disponibilidad[codigo];
                                [anhoIni, mesIni, diaIni] = [fecha.slice(0, 4), fecha.slice(4, 6), fecha.slice(6, 8)];
                                fecha = json.fecha_fin_disponibilidad[codigo];
                                [anhoFin, mesFin, diaFin] = [fecha.slice(0, 4), fecha.slice(4, 6), fecha.slice(6, 8)];
                            }

                            if (json.stock_fabricante[codigo] != 0
                                && json.fecha_ini_disponibilidad[codigo] == "00000000"
                                && json.fecha_fin_disponibilidad[codigo] == "00000000") {
                                $stockFabricante.html(json.stock_fabricante[codigo]);
                                $fechaDisp.html('');

                            } else if (json.stock_fabricante[codigo] == 0 && json.fecha_ini_disponibilidad[codigo] == json.fecha_fin_disponibilidad[codigo] && json.fecha_ini_disponibilidad[codigo] != "00000000"
                                && json.fecha_fin_disponibilidad[codigo] != "00000000") {
                                $stockFabricante.html(json.stock_fabricante[codigo]);
                                $fechaDisp.html(`${diaIni}/${mesIni}/${anhoIni}`);

                            } else if (json.stock_fabricante[codigo] == 0
                                && json.fecha_ini_disponibilidad[codigo] != "00000000"
                                && json.fecha_fin_disponibilidad[codigo] != "00000000") {
                                $stockFabricante.html(json.stock_fabricante[codigo]);
                                $fechaDisp.html(`${diaIni}/${mesIni}/${anhoIni} al ${diaFin}/${mesFin}/${anhoFin}`);

                            } else if (json.stock_fabricante[codigo] != 0
                                && json.fecha_ini_disponibilidad[codigo] != "00000000"
                                && json.fecha_fin_disponibilidad[codigo] != "00000000") {
                                $stockFabricante.html(json.stock_fabricante[codigo]);
                                $fechaDisp.html(`${diaIni}/${mesIni}/${anhoIni} al ${diaFin}/${mesFin}/${anhoFin}`);

                            } else if (json.stock_fabricante[codigo] == 0
                                && json.fecha_ini_disponibilidad[codigo] == "00000000"
                                && json.fecha_fin_disponibilidad[codigo] == "00000000") {
                                $('.stock-fabricante').hide();
                                $('.disp-fabricante').hide();
                            }

                            // Fin ticket #17281
                            $precioNeto.html(json.precio_neto_formatted[codigo]);
                            $precioPvt.html(json.precio_tarifa_formatted[codigo]);
                            var $pvr_mas_alto = false;
                            // Ticket #16124
                            if (json.permiso_pvr == Globals.PERMISO_PVR) {
                                //En este caso no habría que hacer nada ya que el precio ya esta puesto (el dato sale de BD).
                            } else if (json.permiso_pvr == Globals.PERMISO_PVR_PVT_MAS_ALTO) {
                                if (json.precio_tarifa[codigo] > $precio_pvr) {
                                    $labelPrecioPvtPermisoExtra.html("PVT:");
                                    $precioPvtPermisoExtra.html(json.precio_tarifa_formatted[codigo]);
                                } else if (json.precio_tarifa[codigo] <= $precio_pvr) {
                                    $labelPrecioPvtPermisoExtra.html("PVR:");
                                    $precioPvtPermisoExtra.html($precio_pvr_formatted);
                                    $pvr_mas_alto = true;
                                }
                            } else if (json.permiso_pvr == Globals.PERMISO_PVR_PVT_PREVA_PVT) {
                                if (json.precio_tarifa[codigo] > 0) {
                                    $labelPrecioPvtPermisoExtra.html("PVT:");
                                    $precioPvtPermisoExtra.html(json.precio_tarifa_formatted[codigo]);
                                } else {
                                    $labelPrecioPvtPermisoExtra.html("PVR:");
                                    $precioPvtPermisoExtra.html($precio_pvr_formatted);
                                }
                            } else if (json.permiso_pvr == Globals.PERMISO_PVR_PVT_PREVA_PVR) {
                                if ($precio_pvr > 0) {
                                    $labelPrecioPvtPermisoExtra.html("PVR:");
                                    $precioPvtPermisoExtra.html($precio_pvr_formatted);
                                } else {
                                    $labelPrecioPvtPermisoExtra.html("PVT:");
                                    $precioPvtPermisoExtra.html(json.precio_tarifa_formatted[codigo]);
                                }
                            }
                            // Fin ticket #16124

                            if (json.margen_beneficio[codigo]) $margenBeneficio.html(number_format(json.margen_beneficio[codigo], 2, ",", ".") + "%").fadeIn();
                            if (json.margen_beneficio[codigo]) $margenBeneficioCamuflado.html(number_format(json.margen_beneficio[codigo], 2, "", "")).fadeIn();
                            if (json.descuento[codigo] > 0) {
                                $precioNeto.addClass("ex-text-line-trough").removeClass("uk-text-secondary");
                                $precioPvt.addClass("ex-text-line-trough").removeClass("uk-text-secondary");
                                // Ticket #16124
                                if (!$pvr_mas_alto) {
                                    $precioPvtPermisoExtra.addClass("ex-text-line-trough").removeClass("uk-text-secondary");
                                }
                                // Fin ticket #16124
                                $descuento.html("-" + json.descuento[codigo] + "%").fadeIn();
                                $precioDescuento.html(json.precio_descuento_formatted[codigo]).fadeIn();
                                $precioTarifaDescuento.html(json.precio_tarifa_descuento_formatted[codigo]).fadeIn();
                                // Ticket #16124
                                $precioTarifaDescuentoPermisoExtra.html(json.precio_tarifa_descuento_formatted[codigo]).fadeIn();
                                // Fin ticket #16124
                            }

                            if (json.tipo[codigo] && json.tipo[codigo].toLowerCase() == Globals.TIPO_PRODUCTO_PROMOCION.toLowerCase()) {
                                $promo.fadeIn();
                            }

                            $(".spinner").fadeOut(function () {
                                $(".db").fadeIn()
                            });
                        }
                    },
                    error   : function () {
                        $(".spinner").fadeOut(function () {
                            $(".db").fadeIn()
                        });
                    }
                })
            }

            let handle_etiqueta_energetica = function () {
                let contenedor = $(".etiqueta-energetica-central-container");
                let codigo_ean = contenedor.data("codigo_ean");
                if (contenedor.length > 0) {
                    $.ajax({
                        type: "POST",
                        // type: "GET",
                        url: HOST + "/productos/get-etiqueta-energetica",
                        // url: HOST + "/productos/get-etiqueta-energetica-todos/" + codigo_ean,
                        data    : {
                            codigo_ean: codigo_ean
                        },
                        dataType: "json",
                        success : function (json) {
                            if (json.success) {
                                contenedor.html(json.content);
                                contenedor.css("cursor", "pointer");
                                contenedor.off("click").on("click", function () {
                                    if ($(".imagenEtiquetaEnergetica").length == 0) {
                                        let etiqueta_src = $("#ModalEtiquetaEficienciaCentral").data("ruta-s3");
                                        if (etiqueta_src != '') {
                                            let etiqueta = "<img className='imagenEtiquetaEnergetica' src='" + etiqueta_src + "'>";
                                            let lowerCaseUrl = etiqueta_src.toLowerCase();
                                            if(lowerCaseUrl.indexOf('.pdf') > 0) {
                                                etiqueta = "<iframe src='" + etiqueta_src + "#zoom=85' width='450' height='750'></iframe>";
                                            }
                                            let modal = UIkit.modal("<div class='uk-flex-top' uk-modal id='modal-eficiencia-energetica'><div class=\"uk-modal-dialog uk-margin-auto-vertical\"  style='width:auto;'><button class=\"uk-modal-close-outside\" type=\"button\" uk-close></button>"+etiqueta+"<form method=\"post\" action=\"" + HOST + "/download_etiqueta_energetica.php\"><input type='hidden' name='codigo_ean' value='" + codigo_ean + "'><input type='hidden' name='ruta_etiqueta' value='" + etiqueta_src + "'><button type=\"submit\" class='uk-button uk-button-primary' style='width:50%;margin-left:25%;'><span class=\"uk-icon\" uk-icon=\"download\"></span>Descargar</button></form></div></div>");
                                            modal.show();
                                        }
                                    } else {
                                        UIkit.modal("#modal-eficiencia-energetica").show();
                                    }
                                });
                            }
                        }
                    });
                }
            }

            let handle_eficiencia_energetica = function () {
                let contenedor = $(".eficiencia-energetica-central-container");
                let codigo_ean = contenedor.data("codigo_ean");
                if (contenedor.length > 0) {
                    $.ajax({
                        type    : "POST",
                        url     : HOST + "/productos/get-eficiencia-energetica",
                        data    : {
                            codigo_ean: codigo_ean
                        },
                        dataType: "json",
                        success : function (json) {
                            if (json.success) {
                                contenedor.html(json.content);
                            }
                        }
                    });
                }
            }

            HandleFichaIcecat();
            HandlePreciosStocks(codigo);
            handle_etiqueta_energetica();
            handle_eficiencia_energetica();
        }
    };

    let __handleDesgloseDescuentos = function () {
        if ($("#producto-item").length > 0 || $("#page-productos").length > 0) {
            $("[data-desglose-descuento]").off().on("click", function (e) {
                e.preventDefault();
                const codigo = $(this).data("desglose-descuento");
                $.ajax({
                    type    : "GET",
                    url     : HOST + "/productos/desglose-descuento/" + codigo.replaceAll(".", ""),
                    dataType: "json",
                    success : function (json) {
                        console.log(json);
                        if (json.error == 'session_out') {
                            location.href = HOST;
                        } else {
                            const html = json.success ? json.html : "Ha ocurrido un error al cargar el desglose de descuento";
                            UIkit.modal.alert(html, {
                                labels: {
                                    ok: 'Aceptar'
                                }
                            });
                        }
                    }
                });
            });
        }
    };

    let __initFastSearch = function () {
        let $form = $("#fFastSearch");
        if (typeof $form !== "undefined") {
            let $btn = $("#btnFastSearch");

            $btn.off().on("click", function (e) {
                e.preventDefault();
                $form.submit();
            });

            $("input[type='text']", $form).off().on("keyup", function (e) {
                if (e.keyCode == 13) {
                    $form.submit();
                }
            });
        }
    };

    let ChainSelect = function ($obj) {
        $obj.off().on("change", function () {
            let value = $obj.val();
            let type = $obj.data("chain-select-type");
            let $target = $("#" + $obj.data("chain-select"));

            $.ajax({
                type    : "GET",
                url     : HOST + "/chain-select/" + value + "/" + type,
                dataType: "json",
                success : function (json, status, xhr) {
                    if (json.error == 'session_out') {
                        location.href = HOST;
                    } else {
                        if (json.success) {
                            $target.html(json.html);

                            if ($("option", $target).length === 2) {
                                $target.val($("option[value!='']", $target).val());
                            }
                        }
                    }
                }
            });
        });
    };

    let __initChainSelects = function () {
        $("select[data-chain-select]").each(function () {
            ChainSelect($(this));
        });
    };

    let __initMargenes = function () {
        let handleMargenDefecto = function () {
            let $form = $("#fMargenDefecto");
            $("input[name='margenDefecto']", $form).off().on("change", function () {
                let margenDefecto = $(this).val();
                if (margenDefecto !== "" && margenDefecto !== "0") {
                    $.ajax({
                        type    : "post",
                        url     : HOST + "/mi-cuenta/margenes/saveDefecto",
                        dataType: "json",
                        data    : {
                            margenDefecto: margenDefecto
                        },
                        success : function (json) {
                            if (json.success) {
                                Notificacion("Se ha modificado el margen por defecto correctamente", "success");
                            } else {
                                Notificacion("Ha ocurrido un error al intentar modificar el margen por defecto", "danger");
                            }
                        }
                    });
                } else {
                    __alert({
                        msg: "El margen tiene que tener un valor mayor que 0"
                    });
                }
            });
        };

        $(".btnDel").off().on("click", function (e) {
            e.preventDefault();
            DeleteMargen($(this).data("id"));
        });

        $("input[name='select_all']").off().on("click", function () {
            let checked = !!$(this).is(":checked");
            $(this).prop("checked", checked);
            $("input[name='seleccion[]']").prop("checked", checked);
        });

        $("[data-action='delSelected']").off().on('click', function (e) {
            e.preventDefault();
            const selected = $("input[name='seleccion[]']:checked");
            let toDel = [];
            if (typeof selected != "undefined") {
                selected.each(function (index, elem) {
                    toDel.push($(elem).val());
                });
            }

            if (toDel.length === 0) {
                __alert({
                    title: 'Atención',
                    msg  : 'No hay elementos seleccionados'
                });
            } else {
                __confirm({
                    title      : "Se va a eliminar los márgenes seleccionados. ¿Continuar?",
                    msg        : 'Una vez eliminados, no se podrán recuperar',
                    callback_ok: function () {
                        $.ajax({
                            type      : "DELETE",
                            url       : HOST + "/mi-cuenta/margenes/delSelected/" + JSON.stringify(toDel),
                            dataType  : "json",
                            success   : function (json) {
                                let msg = '';
                                let status = '';
                                let reload = false;
                                if (json.error == 'session_out') {
                                    location.href = HOST;
                                } else if (json.success) {
                                    msg = 'Los márgenes se eliminaron correctamente';
                                    status = 'success';
                                    reload = true;

                                } else {
                                    msg = 'Ha ocurrido un error al eliminar los márgenes. Por favor, inténtalo de nuevo más tarde.';
                                    status = 'danger';
                                }
                                Notificacion(msg, status);
                                if (reload || redir) {
                                    setTimeout(function () {
                                        if (("#margen-item").length > 0) {
                                            location.href = HOST + "/mi-cuenta/margenes";
                                        } else {
                                            location.reload();
                                        }
                                    }, 3000);
                                }
                            },
                            error     : function () {
                                Notificacion("Ha ocurrido un error al eliminar los márgenes. Por favor, inténtalo de nuevo más tarde.", "danger");
                            },
                            beforeSend: function () {
                                __unblockUI({
                                    msg: '<i uk-spinner="ratio: 0.8"></i> Eliminando márgenes...'
                                })
                            }
                        });
                    }
                });
            }
        })


        handleMargenDefecto();
    };

    let __initMargen = function () {
        let $margenItem = $("#margen-item");
        if ($margenItem.length > 0) {
            let $form = $("#fMargen");

            let HandleChangeTipo = function () {
                $("select[name='tipo']").off().on("change", function () {
                    let toShow = $("option:selected", $(this)).data("set-visible");
                    $(".margen-tipo").fadeOut(
                        function () {
                            $("#" + toShow).fadeIn();
                        }
                    );

                    let $idLinea = $("#id_linea", $form);
                    let $codigoMarca = $("#codigo_marca", $form);
                    let $producto = $("#producto", $form);
                    let $codigoProducto = $("#codigo_producto", $form);
                    if (toShow === "form-tipo-producto") {
                        $idLinea.rules("remove", "require_from_group");
                        $codigoMarca.rules("remove", "require_from_group");
                        $producto.rules("add", "required");
                        $codigoProducto.rules("add", "required");
                    } else {
                        $producto.rules("remove", "required");
                        $codigoProducto.rules("remove", "required");
                        $idLinea.rules("add", {
                            require_from_group: [1, ".required_group"]
                        });
                        $codigoMarca.rules("add", {
                            require_from_group: [1, ".required_group"]
                        });
                    }
                });
            };
            let HandleForm = function () {
                $form.validate({
                    rules        : {
                        margen: {
                            required: true
                        },
                        nombre: {
                            required: true
                        },
                        tipo  : {
                            required: true
                        }
                    },
                    messages     : {
                        margen         : {
                            required: "Es necesario indicar un valor de margen"
                        },
                        nombre         : {
                            required: "Es necesario indicar un nombre al margen"
                        },
                        tipo           : {
                            required: "Es necesario indicar un tipo de margen"
                        },
                        id_linea       : {
                            require_from_group: "Es necesario indicar una línea y/o marca"
                        },
                        codigo_marca   : {
                            require_from_group: "Es necesario indicar una línea y/o marca"
                        },
                        codigo_producto: {
                            required: "Obligatorio"
                        },
                        producto       : {
                            required: "Es necesario indicar un producto"
                        }
                    },
                    submitHandler: function (form) {
                        $(form).ajaxSubmit({
                            dataType  : "json",
                            beforeSend: function () {
                                __blockUI({
                                    msg: '<i uk-spinner="ratio: 0.8"></i> Guardando el margen...'
                                });
                            },
                            success   : function (json) {
                                let msg = "";
                                let status = "";
                                let redir = false;
                                if (json.success) {
                                    msg = "Se ha guardado correctamente el margen";
                                    status = "success";
                                    redir = json.redir ? parseInt(json.id) : false;
                                } else {
                                    msg = "Ha ocurrido un error a la hora de guardar el margen";
                                    status = "danger";
                                }
                                Notificacion(msg, status);
                                if (redir !== false && Number.isInteger(redir)) {
                                    setTimeout(function () {
                                            location.href = HOST + "/mi-cuenta/margenes/" + json.id
                                        },
                                        5000
                                    );
                                }
                                __unblockUI();
                            }
                        });
                    }
                });

                $(".btnBack").off().on("click", function (e) {
                    e.preventDefault();
                    history.back();
                });
                $(".btnDel").off().on("click", function (e) {
                    e.preventDefault();
                    DeleteMargen($(this).data("id"));
                });
                $(".btnSave").off().on("click", function (e) {
                    e.preventDefault();
                    $form.submit();
                });

                let productos = new Bloodhound({
                    datumTokenizer: function (d) {
                        return Bloodhound.tokenizers.whitespace(d.id);
                    },
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote        : {
                        url     : HOST + '/productos/autocomplete/%QUERY',
                        wildcard: '%QUERY'
                    }
                });
                productos.initialize();


                $('#producto').typeahead(null, {
                    limit     : 30,
                    name      : 'productos',
                    displayKey: 'titulo',
                    source    : productos.ttAdapter(),
                    hint      : false,
                    templates : {
                        empty     : [
                            '<p>No hay resultados</p>'
                        ].join('\n'),
                        suggestion: function (data) {
                            return '<p><strong>' + data.codigo + '</strong> - ' + data.titulo + ' </p>';
                        }
                    }
                }).on('typeahead:selected', function (event, obj) {
                    if (typeof (obj) != 'undefined') {
                        $("#codigo_producto").val(obj.codigo);
                    }
                }).on('blur', function (event, obj) {

                });
            };

            HandleChangeTipo();
            HandleForm();
        }
    };

    let DeleteMargen = function (id) {
        __confirm({
            title      : '¿Eliminar el margen seleccionado?',
            msg        : 'Una vez eliminado, no habrá vuelta atrás',
            callback_ok: function () {
                $.ajax({
                    type      : "DELETE",
                    url       : HOST + "/mi-cuenta/margenes/del/" + id,
                    dataType  : "json",
                    success   : function (json) {
                        let msg = '';
                        let status = '';
                        let reload = false;
                        if (json.error == 'session_out') {
                            location.href = HOST;
                        } else if (json.success) {
                            msg = 'El margen se ha eliminado correctamente';
                            status = 'success';
                            reload = true;

                        } else {
                            msg = 'Ha ocurrido un error al eliminar el margen. Por favor, inténtalo de nuevo más tarde.';
                            status = 'danger';
                        }
                        Notificacion(msg, status);
                        if (reload || redir) {
                            setTimeout(function () {
                                if (("#margen-item").length > 0) {
                                    location.href = HOST + "/mi-cuenta/margenes";
                                } else {
                                    location.reload();
                                }
                            }, 3000);
                        }
                    },
                    error     : function () {
                        Notificacion("Ha ocurrido un error al eliminar el margen. Por favor, inténtalo de nuevo más tarde.", "danger");
                    },
                    beforeSend: function () {
                        __unblockUI({
                            msg: '<i uk-spinner="ratio: 0.8"></i> Eliminando margen...'
                        })
                    }
                });
            }
        });
        // UIkit.modal.confirm('Se va a eliminar el margen seleccionado. ¿Continuar?', {
        //     labels: {
        //         cancel: "Cancelar",
        //         ok: "Confirmar"
        //     }
        // }).then(function () {
        //     $.ajax({
        //         type: "DELETE",
        //         url: HOST + "/mi-cuenta/margenes/del/" + id,
        //         dataType: "json",
        //         success: function (json) {
        //             let msg = '';
        //             let status = '';
        //             let reload = false;
        //             if (json.error == 'session_out') {
        //                 location.href = HOST;
        //             } else if (json.success) {
        //                 msg = '<span uk-icon="icon: check"></span> El margen se ha eliminado correctamente';
        //                 status = 'success';
        //                 reload = true;
        //
        //             } else {
        //                 msg = '<span uk-icon="icon:warning"></span> Ha ocurrido un error al eliminar el margen. Por favor, inténtalo de nuevo más tarde.';
        //                 status = 'danger';
        //             }
        //             Notificacion(msg, status);
        //             if (reload || redir) {
        //                 setTimeout(function () {
        //                     if (("#margen-item").length > 0) {
        //                         location.href = HOST + "/mi-cuenta/margenes";
        //                     } else {
        //                         location.reload();
        //                     }
        //                 }, 3000);
        //             }
        //         },
        //         error: function () {
        //             Notificacion("Ha ocurrido un error al eliminar el margen. Por favor, inténtalo de nuevo más tarde.", "danger");
        //         },
        //         beforeSend: function () {
        //             __unblockUI({
        //                 msg: '<i uk-spinner="ratio: 0.8"></i> Eliminando margen...'
        //             })
        //         }
        //     });
        // });
    };

    let HandleEventsProducts = function () {
        //Acciones
        let HandleActions = function () {
            $(".ex-product-action").off().on("click", function (e) {
                e.preventDefault();
                switch ($(this).data("action")) {
                    case "add-pedido":
                        AddProductoPedido($(this).data("codigo"), $("input[name='cantidad']").val() ?? 1);
                        break;

                    case "add-presupuesto":
                        AddProductoPresupuesto($(this).data("codigo"), $("input[name='cantidad']").val() ?? 1);
                        break;

                    case "add-etiqueta":
                        GenerateProductoEtiqueta($(this).data("codigo"));
                        break;

                    case "add-comparador":
                        AddProductoComparador($(this).data("codigo"), $(this).data('add'));
                        break;

                    case "add-favoritos":
                        AddProductoFavoritos($(this).data("codigo"), $(this).data("add"));
                        break;

                    case "vaciar-favoritos":
                        vaciarFavoritos();
                        break;
                }
            });
        };

        HandleActions();
    };

    let AddProductoPedido = function (codigo, cantidad) {
        $.ajax({
            type      : "PUT",
            url       : HOST + "/pedidos/add/" + codigo + "/" + cantidad,
            dataType  : "json",
            beforeSend: function () {
                __blockUI({
                    msg: '<i uk-spinner="ratio: 0.8"></i> Agregando producto al pedido...'
                });
            },
            success   : function (json) {
                __unblockUI();
                let msg = "";
                let status = "";
                if (json.success) {
                    msg = 'El producto se ha añadido correctamente a tu pedido';
                    status = "success";
                    $("span#header-pedido").text(json.num_productos).fadeIn();
                    const $obj = $(".ex-product-action[data-action='add-pedido'][data-codigo='" + codigo + "']");
                    $obj.removeClass('uk-button-secondary').addClass('uk-button-danger');
                } else {
                    msg = json.msg ?? 'Ha ocurrido un error al añadir el producto a tu pedido';
                    status = "danger";
                }
                Notificacion(msg, status);
            },
            complete  : function () {
                __unblockUI();
            },
            error     : function () {
                Notificacion('Ha ocurrido un error al añadir el producto a tu pedido', 'danger');
                __unblockUI();
            }
        });
    };

    let AddProductoPresupuesto = function (codigo, cantidad) {
        $.ajax({
            type      : "PUT",
            url       : HOST + "/presupuestos/add/" + codigo + "/" + cantidad,
            dataType  : "json",
            beforeSend: function () {
                __blockUI({
                    msg: '<i uk-spinner="ratio: 0.8"></i> Agregando producto al presupuesto...'
                });
            },
            success   : function (json) {
                __unblockUI();
                let msg = "";
                let status = "";
                if (json.success) {
                    msg = 'El producto se ha añadido correctamente a tu presupuesto';
                    status = "success";
                    $("span#header-presupuesto").text(json.num_productos).fadeIn();
                    const $obj = $(".ex-product-action[data-action='add-presupuesto'][data-codigo='" + codigo + "']");
                    $obj.removeClass('uk-button-secondary').addClass('uk-button-danger');
                } else {
                    msg = json.msg ?? 'Ha ocurrido un error al añadir el producto a tu presupuesto';
                    status = "danger";
                }
                Notificacion(msg, status);
            },
            complete  : function () {
                __unblockUI();
            },
            error     : function () {
                Notificacion('Ha ocurrido un error al añadir el producto a tu presupuesto', 'danger');
                __unblockUI();
            }
        });
    };

    let GenerateProductoEtiqueta = function (codigo) {
        Notificacion("En construcción", "primary");
    };

    let AddProductoComparador = function (codigo, add) {
        const addDel = add > 0 ? 'add' : 'del';
        $.ajax({
            type      : 'POST',
            url       : HOST + '/comparador/' + addDel + '/' + codigo,
            dataType  : 'json',
            beforeSend: function () {
                let msg = add > 0 ? 'Agregando producto a comparador...' : 'Eliminando producto de comparador...'
                __blockUI({
                    msg: '<i uk-spinner="ratio: 0.8"></i> ' + msg
                })
            },
            success   : function (json) {
                __unblockUI();
                let msg = '';
                let status = '';
                if (json.success) {
                    msg = json.msg;
                    status = 'success';
                    $("span#header-comparador").text(json.num_productos).fadeIn();
                    let $obj = $(".ex-product-action[data-action='add-comparador'][data-codigo='" + codigo + "']");
                    $obj.data('add', (add * -1));
                    if (add * -1 > 0) {
                        if ($("#page-comparador").length > 0) {
                            $(".ex-producto[data-codigo='" + codigo + "']").parent().fadeOut();
                        } else {
                            $obj.removeClass('uk-button-danger').addClass('uk-button-secondary');
                            $obj.attr('uk-tooltip', 'title: Añadir a Comparador');
                        }
                    } else {
                        $obj.removeClass('uk-button-secondary').addClass('uk-button-danger');
                        $obj.attr('uk-tooltip', 'title: Quitar de Comparador');
                    }
                } else {
                    msg = json.msg;
                    status = 'danger';
                }
                Notificacion(msg, status);
            }
        });
    };

    let AddProductoFavoritos = function (codigo, add) {
        const addDel = add > 0 ? 'add' : 'del';
        $.ajax({
            type      : 'POST',
            url       : HOST + '/favoritos/' + addDel + '/' + codigo,
            dataType  : 'json',
            beforeSend: function () {
                let msg = add > 0 ? 'Agregando producto a favoritos...' : 'Eliminando producto de favoritos...'
                __blockUI({
                    msg: '<i uk-spinner="ratio: 0.8"></i> ' + msg
                });
            },
            success   : function (json) {
                __unblockUI();
                let msg = "";
                let status = "";
                if (json.success) {
                    msg = json.msg;
                    status = "success";
                    let $obj = $(".ex-product-action[data-action='add-favoritos'][data-codigo='" + codigo + "']");
                    if ($("#page-favoritos").length > 0 && (add * -1) === 1) {
                        $obj.parents('.ex-producto').fadeOut(function () {
                            $(this).remove();
                        });
                    } else {
                        $obj.data('add', (add * -1));
                        if (add * -1 > 0) {
                            $obj.removeClass('uk-button-danger').addClass('uk-button-secondary');
                            $obj.attr('uk-tooltip', 'title: Añadir a Favoritos');
                        } else {
                            $obj.removeClass('uk-button-secondary').addClass('uk-button-danger');
                            $obj.attr('uk-tooltip', 'title: Quitar de Favoritos');
                        }
                    }
                } else {
                    msg = json.msg;
                    status = "danger";
                }
                Notificacion(msg, status);
            },
            complete  : function () {
                __unblockUI();
            },
            error     : function () {
                Notificacion('Ha ocurrido un error al añadir el producto a tu pedido', 'danger');
                __unblockUI();
            }
        });
    };

    let vaciarFavoritos = function () {
        __confirm({
            title      : "Se vaciará la lista de favoritos. ¿Continuar?",
            callback_ok: function () {
                $.ajax({
                    type      : 'POST',
                    url       : HOST + '/favoritos/empty',
                    dataType  : 'json',
                    beforeSend: function () {
                        __blockUI({
                            msg: '<i uk-spinner="ratio: 0.8"></i> Vaciando lista de favoritos...'
                        });
                    },
                    success   : function (json) {
                        if (json.success) {
                            Notificacion('Se ha vaciado la lista de favoritos correctamente', 'success');
                            setTimeout(function () {
                                location.href = HOST + '/productos?o=2'
                            }, 2000);
                        } else {
                            Notificacion('Ha ocurrido un error al vaciar la lista de favoritos', 'danger');
                        }
                    }
                });
            }
        });
        // if (__confirm("Se vaciará la lista de favoritos. ¿Continuar?", function () {
        //     $.ajax({
        //         type: 'POST',
        //         url: HOST + '/favoritos/empty',
        //         dataType: 'json',
        //         beforeSend: function () {
        //             __blockUI({
        //                 msg: '<i uk-spinner="ratio: 0.8"></i> Vaciando lista de favoritos...'
        //             });
        //         },
        //         success: function (json) {
        //             if (json.success) {
        //                 Notificacion('Se ha vaciado la lista de favoritos correctamente', 'success');
        //                 setTimeout(function () {
        //                     location.href = HOST + '/productos?o=2'
        //                 }, 2000);
        //             } else {
        //                 Notificacion('Ha ocurrido un error al vaciar la lista de favoritos', 'danger');
        //             }
        //         }
        //     });
        // })) ;
    };

    let Notificacion = function (msg, status, timer, confirmButton) {
        let icon = "";

        switch (status) {
            case "primary":
                icon = 'info';
                break;

            case "success":
                icon = 'success';
                break;

            case "warning":
                icon = 'warning';
                break;

            case "danger":
                icon = 'error';
                break;
        }

        const Toast = Swal.mixin({
            toast            : true,
            position         : 'top',
            showConfirmButton: confirmButton ?? false,
            timer            : timer ?? 3000,
            timerProgressBar : true
        });

        Toast.fire({
            icon : icon,
            title: msg
        });

    };

    let __initPedidoPresupuesto = function () {

        let type = 0;
        if ($("#page-presupuestos").length > 0) {
            type = TYPE_PRESUPUESTOS;
        } else if ($("#page-pedidos").length > 0) {
            type = TYPE_PEDIDOS;
        }

        if ([TYPE_PRESUPUESTOS, TYPE_PEDIDOS].includes(type)) {

            const string_type = type === TYPE_PRESUPUESTOS ? 'presupuestos' : 'pedidos';
            const id = type === TYPE_PRESUPUESTOS ? $('#presupuesto-item').data('id') : $('#pedido-item').data('id');

            let LoadPreciosNetos = function () {
                let codigos = "";
                // let id_pedido = $("#pedido-item").data("id");
                $(".row-producto").each(function (index, elem) {
                    codigos += $(elem).data("codigo") + ",";
                });
                if (codigos !== "") {
                    codigos = codigos.substring(0, codigos.length - 1);
                    $.ajax({
                        type    : "GET",
                        url     : HOST + "/productos/precio-stock/" + codigos + "/" + type + "/" + id,
                        dataType: "json",
                        success : function (json, status, xhr) {
                            if (json.success) {
                                let total_row = 0;
                                let total_descuento = 0;
                                let total = 0;

                                $.each(json.precio_descuento, function (codigo, precio_descuento) {
                                    if (precio_descuento > 0) {
                                        $(".precio", $(".row-producto[data-codigo='" + codigo + "']")).html(FormatoPrecio(precio_descuento) + "&euro;").addClass("descuento");
                                        if (precio_descuento != json.precio_neto[codigo]) {
                                            $(".precio-neto", $('.row-producto[data-codigo="' + codigo + '"]')).html(FormatoPrecio(json.precio_neto[codigo]) + '&euro;').addClass("ex-text-line-trough uk-text-muted")
                                        }
                                        if (json.descuento[codigo] > 0) {
                                            $("label.descuento", $(".row-producto[data-codigo='" + codigo + "']")).html("-" + json.descuento[codigo] + "%").fadeIn();
                                        }
                                        if (type === TYPE_PEDIDOS) {
                                            total_row = precio_descuento * parseInt($("input[name='cantidad_" + codigo + "']").val());
                                            $(".total_row", $(".row-producto[data-codigo='" + codigo + "']")).html(FormatoPrecio(total_row) + "&euro;").addClass("descuento");
                                            total_descuento = total_row;
                                            total += !isNaN(total_row) ? total_row : 0;
                                        }
                                    } else {
                                        total_descuento = 0;
                                    }
                                });
                                /*$.each(json.precio_neto, function (codigo, precio_neto) {
                                    $(".precio-neto", $(".row-producto[data-codigo='" + codigo + "']")).html(FormatoPrecio(precio_neto) + "&euro;");
                                    total = precio_neto * parseInt($("input[name='cantidad_" + codigo + "']").val());
                                    $(".total:not('.descuento')", $(".row-producto[data-codigo='" + codigo + "']")).html(FormatoPrecio(total) + "&euro;");
                                    if (total_descuento === 0 && !isNaN(total) && total > 0) {
                                        total_pedido += total;
                                    }
                                });*/

                                if (total > 0) {
                                    $(".total").html(FormatoPrecio(total) + "&euro;");
                                }
                            } else {

                            }
                            $(".spinner").fadeOut(function () {
                                $(".db").fadeIn()
                            });
                        },
                        error   : function () {
                            $(".spinner").fadeOut(function () {
                                $(".db").fadeIn()
                            });
                        }
                    });
                } else {
                    $('.total').html(FormatoPrecio(0) + '&euro;')
                }
            };

            const recargaListadoProductos = function () {
                $.ajax({
                    type    : "GET",
                    url     : HOST + "/presupuestos/productos/" + id,
                    dataType: "json",
                    success : function (json, status, xhr) {
                        if (json.success) {
                            $("div#listProductosPresupuesto").html(json.html);
                            __initPedidoPresupuesto();
                        }
                    }
                });
            }

            let HandleActionsProductos = function () {
                $(".del-product").off().on("click", function (e) {
                    e.preventDefault();
                    let codigo = $(this).parents("tr").data("codigo");
                    EliminarProducto(codigo);
                });

                $("input[name^='cantidad']").off().on("change", function (e) {
                    let codigo = $(this).attr("name").replace("cantidad_", "");
                    let cantidad = parseInt($(this).val());
                    if (isNaN(cantidad)) {
                        __alert({
                            msg: "Por favor, indica una cantidad correcta"
                        });
                    } else {
                        if (cantidad <= 0) {
                            EliminarProducto(codigo);
                        } else {
                            CambiaCantidadProducto(codigo, cantidad, $(this).data("value"));
                        }
                    }
                });

                if (type === TYPE_PRESUPUESTOS) {
                    $('input[name^="precio_"], input[name^="descuento_"]').off().on('change', function () {
                        const element = $(this).attr('name').split('_')[0];
                        const codigo = $(this).attr('name').replace(element + '_', '');
                        const value = parseFloat($(this).val());
                        if (isNaN(value)) {
                            const msg = element == 'precio' ? 'Por favor, indica un precio correcto' : 'Por favor, indica un descuento correcto';
                            __alert({
                                msg: msg
                            });
                        } else {
                            if (value < 0) {
                                __alert({
                                    msg: 'No se permiten valores negativos'
                                })
                                $("input[name='" + element + "_" + codigo + "']").val($(this).data('value'));
                            } else {
                                cambiaPrecioDescuentoProducto(codigo, value, element, $(this).data('value'));
                            }
                        }

                    });
                }
            }

            let CambiaCantidadProducto = function (codigo, cantidad, prevValue) {
                $.ajax({
                    type      : "PUT",
                    url       : HOST + "/" + string_type + "/chg-cant/" + id + "/" + codigo + "/" + cantidad,
                    dataType  : "json",
                    beforeSend: function () {
                        __blockUI({
                            msg: '<i uk-spinner="ratio: 0.8"></i> Actualizando unidades...'
                        });
                    },
                    success   : function (json) {
                        __unblockUI();
                        let msg = "";
                        let status = "";
                        if (json.success) {
                            const $header = type === TYPE_PRESUPUESTOS ? $('span#header-presupuesto') : $('span#header-pedidos');
                            $header.text(json.num_productos);
                            $("input[name='cantidad_" + codigo + "']").attr("data-value", cantidad);
                            if (type === TYPE_PEDIDOS) {
                                LoadPreciosNetos();
                            } else {
                                recargaListadoProductos();
                            }
                        } else {
                            msg = json.msg ?? 'Ha ocurrido un error al actualizar las unidades del producto';
                            status = "danger";
                            Notificacion(msg, status);
                            $("input[name='cantidad_" + codigo + "']").val(prevValue);
                        }
                    },
                    complete  : function () {
                        __unblockUI();
                    },
                    error     : function () {
                        Notificacion('Ha ocurrido un error al actualizar las unidades del producto', 'danger');
                        $("input[name='cantidad_" + codigo + "']").val(prevValue);
                        __unblockUI();
                    }
                });
            }

            const cambiaPrecioDescuentoProducto = function (codigo, value, element, prevValue) {
                const action = element == 'precio' ? 'chg-prec' : 'chg-desc';

                $.ajax({
                    type      : 'PUT',
                    url       : HOST + '/' + string_type + '/' + action + '/' + id + '/' + codigo + '/' + value,
                    dataType  : 'json',
                    beforeSend: function () {
                        __blockUI({
                            msg: '<i uk-spinner="ratio: 0.8"></i> Actualizando ' + element + '...'
                        });
                    },
                    success   : function (json) {
                        __unblockUI();
                        let msg = "";
                        let status = "";
                        if (json.success) {
                            const $header = $('span#header-presupuesto');
                            $header.text(json.num_productos);
                            $("input[name='cantidad_" + codigo + "']").attr("data-value", value);
                            if (type === TYPE_PEDIDOS) {
                                LoadPreciosNetos();
                            } else {
                                recargaListadoProductos();
                            }
                        } else {
                            msg = json.msg ?? 'Ha ocurrido un error al actualizar el ' + element + ' del producto';
                            status = "danger";
                            Notificacion(msg, status);
                            $("input[name='" + element + "_" + codigo + "']").val(prevValue);
                        }
                    }
                });
            };

            let EliminarProducto = function (codigo) {
                let EliminarProductoDo = function (codigo) {

                    let url = HOST + '/' + string_type + '/sub';
                    if (type === TYPE_PRESUPUESTOS) {
                        url += '/' + id;
                    }
                    url += '/' + codigo

                    $.ajax({
                        type      : "PUT",
                        url       : url,
                        dataType  : "json",
                        beforeSend: function () {
                            const msg = type === TYPE_PRESUPUESTOS ? 'Eliminando producto del presupuesto...' : 'Eliminando producto del pedido...';
                            __blockUI({
                                msg: '<i uk-spinner="ratio: 0.8"></i> ' + msg
                            });
                        },
                        success   : function (json) {
                            __unblockUI();
                            let msg = "";
                            let status = "";
                            if (json.success) {
                                msg = type === TYPE_PRESUPUESTOS ? 'El producto se ha eliminado correctamente de tu presupuesto' : 'El producto se ha eliminado correctamente de tu pedido';
                                status = "success";
                                $("span#header-pedido").text(json.num_productos);
                                $("tr.row-producto[data-codigo='" + codigo + "']").fadeOut(
                                    function () {
                                        $(this).remove();
                                    }
                                );
                                if (type === TYPE_PEDIDOS) {
                                    LoadPreciosNetos();
                                } else {
                                    recargaListadoProductos();
                                    __initPedidoPresupuesto();
                                }

                            } else {
                                msg = json.msg ?? (type === TYPE_PRESUPUESTOS ? 'Ha ocurrido un error al eliminar el producto de tu presupuesto' : 'Ha ocurrido un error al eliminar el producto de tu pedido');
                                status = "danger";
                            }
                            Notificacion(msg, status);
                        },
                        complete  : function () {
                            __unblockUI();
                        },
                        error     : function () {
                            Notificacion((type === TYPE_PRESUPUESTOS ? 'Ha ocurrido un error al eliminar el producto de tu presupuesto' : 'Ha ocurrido un error al eliminar el producto de tu pedido'), 'danger');
                            __unblockUI();
                        }
                    });
                };
                // __confirm((type === TYPE_PRESUPUESTOS ? 'Se va a eliminar el producto del presupuesto. ¿Continuar?' : "Se va a eliminar el producto del pedido. ¿Continuar?"), function () {
                //     EliminarProductoDo(codigo);
                // });
                __confirm({
                    title      : (type === TYPE_PRESUPUESTOS ? 'Se va a eliminar el producto del presupuesto. ¿Continuar?' : "Se va a eliminar el producto del pedido. ¿Continuar?"),
                    callback_ok: function () {
                        EliminarProductoDo(codigo);
                    }
                });
            }

            let deletePresupuesto = function (id_presupuesto) {
                let id = typeof id_presupuesto !== 'undefined' ? id_presupuesto : $("input[name='id']").val();
                // __confirm("Se va a eliminar el presupuesto. ¿Continuar?", function () {
                //     $.ajax({
                //         type: "DELETE",
                //         url: HOST + "/presupuestos/del/" + id,
                //         dataType: "json",
                //         success: function (json) {
                //             if (json.success) {
                //                 Notificacion("Se ha eliminado el presupuesto correctamente", "success");
                //                 setTimeout(function () {
                //                     if ($("#presupuesto-item").length > 0) {
                //                         location.href = json.redir;
                //                     } else {
                //                         location.reload();
                //                     }
                //                 }, 2000);
                //             } else {
                //                 Notificacion("Ha ocurrido un error al intentar eliminar el presupuesto", "danger");
                //             }
                //         }
                //     });
                // });
                __confirm({
                    title      : 'Se va a eliminar el presupuesto. ¿Continuar?',
                    msg        : 'Una vez confirmado, no se podrá recuperar el presupuesto',
                    callback_ok: function () {
                        $.ajax({
                            type    : "DELETE",
                            url     : HOST + "/presupuestos/del/" + id,
                            dataType: "json",
                            success : function (json) {
                                if (json.success) {
                                    Notificacion("Se ha eliminado el presupuesto correctamente", "success");
                                    setTimeout(function () {
                                        if ($("#presupuesto-item").length > 0) {
                                            location.href = json.redir;
                                        } else {
                                            location.reload();
                                        }
                                    }, 2000);
                                } else {
                                    Notificacion("Ha ocurrido un error al intentar eliminar el presupuesto", "danger");
                                }
                            }
                        });
                    }
                })
            };

            let selectPresupuesto = function (id_presupuesto) {
                // __confirm('Se va a seleccionar este presupuesto. ¿Continuar?', function () {
                //     $.ajax({
                //         type: 'GET',
                //         url: HOST + '/presupuestos/select/' + id_presupuesto,
                //         dataType: 'json',
                //         success: function (json) {
                //             if (json.success) {
                //                 Notificacion('Se ha seleccionado el presupuesto correctamente', 'success');
                //                 setTimeout(function () {
                //                     location.reload();
                //                 }, 2000);
                //             } else {
                //                 Notificacion('Ha ocurrido un problema al intentar seleccionar el presupuesto', 'danger');
                //             }
                //         }
                //     })
                // });
                __confirm({
                    title      : 'Se va a seleccionar este presupuesto. ¿Continuar?',
                    callback_ok: function () {
                        $.ajax({
                            type    : 'GET',
                            url     : HOST + '/presupuestos/select/' + id_presupuesto,
                            dataType: 'json',
                            success : function (json) {
                                if (json.success) {
                                    Notificacion('Se ha seleccionado el presupuesto correctamente', 'success');
                                    setTimeout(function () {
                                        location.reload();
                                    }, 2000);
                                } else {
                                    Notificacion('Ha ocurrido un problema al intentar seleccionar el presupuesto', 'danger');
                                }
                            }
                        })
                    }
                });
            }

            let HandleForm = function () {
                let $form = type === TYPE_PRESUPUESTOS ? $("#fPresupuesto") : $("#fPedido");

                if (type === TYPE_PEDIDOS) {
                    $("select[name='cod_direccion']").off().on("change", function () {
                        let nombre = $("option:selected", $(this)).data("nombre") ?? "";
                        let direccion = $("option:selected", $(this)).data("direccion") ?? "";
                        let poblacion = $("option:selected", $(this)).data("poblacion") ?? "";

                        $("input[name='direccion_nombre']").val(nombre);
                        $("input[name='direccion_direccion']").val(direccion);
                        $("input[name='direccion_poblacion']").val(poblacion);
                    });

                    $("input[name='observaciones_cliente']").off().on("keyup", function (e) {
                        let characters = $(this).val().length;
                        $("i.countCaracteres").text(characters);
                        let $contador = $("#limitCaracteresObservaciones");
                        if (characters >= 30) {
                            $($contador).removeClass("uk-text-warning").addClass("uk-text-danger");
                        } else if (characters >= 25) {
                            $($contador).removeClass("uk-text-danger").addClass("uk-text-warning");
                        } else {
                            $($contador).removeClass("uk-text-warning uk-text-danger");
                        }
                    });

                    $("input[name='proxima_ruta']").off().on("click", function (e) {
                        $("input[name='fecha_entrega']").attr("disabled", $(this).is(":checked"));
                    });

                    $("#send-pedido").off().on("click", function (e) {
                        $this = $(this);
                        e.preventDefault();
                        // __confirm('Vas a enviar el pedido a la central. Esto no tiene marcha atrás ¿Continuar?', function () {
                        //     let prevAction = $("#fPedido").attr("action");
                        //     $("#fPedido").attr("action", $this.data("action"));
                        //     $("#fPedido-send").trigger('click');
                        //     $("#fPedido").attr("action", prevAction);
                        // });
                        __confirm({
                            title      : 'Vas a enviar el pedido a la central. ¿Continuar?',
                            msg        : 'Una vez enviado, no se podrán realizar modificaciones sobre el mismo',
                            callback_ok: function () {
                                let prevAction = $("#fPedido").attr("action");
                                $("#fPedido").attr("action", $this.data("action"));
                                $("#fPedido-send").trigger('click');
                                $("#fPedido").attr("action", prevAction);
                            }
                        });
                    });

                    let deletePedido = function () {
                        let id = $("input[name='id']").val();
                        // __confirm("Se va a eliminar el pedido en curso. ¿Continuar?", function () {
                        //     $.ajax({
                        //         type: "DELETE",
                        //         url: HOST + "/pedidos/del/" + id,
                        //         dataType: "json",
                        //         success: function (json) {
                        //             if (json.success) {
                        //                 Notificacion("Se ha eliminado el pedido correctamente", "success");
                        //                 setTimeout(function () {
                        //                     console.log(json);
                        //                     location.href = json.redir;
                        //                 }, 2000);
                        //             } else {
                        //                 Notificacion("Ha ocurrido un error al intentar eliminar el pedido", "danger");
                        //             }
                        //         }
                        //     });
                        // });
                        __confirm({
                            title      : 'Se va a eliminar el pedido en curso. ¿Continuar?',
                            msg        : 'Una vez confirmado, no se podrá recuperar el pedido',
                            callback_ok: function () {
                                $.ajax({
                                    type    : "DELETE",
                                    url     : HOST + "/pedidos/del/" + id,
                                    dataType: "json",
                                    success : function (json) {
                                        if (json.success) {
                                            Notificacion("Se ha eliminado el pedido correctamente", "success");
                                            setTimeout(function () {
                                                location.href = json.redir;
                                            }, 2000);
                                        } else {
                                            Notificacion("Ha ocurrido un error al intentar eliminar el pedido", "danger");
                                        }
                                    }
                                });
                            }
                        })
                    };

                    $("#delete-pedido").off().on("click", function (e) {
                        e.preventDefault();
                        deletePedido();
                    })

                    let RequiredHabitual = function () {
                        return $("input[name='tipo_envio']").val() === Globals.PEDIDO_TIPO_ENVIO_HABITUAL;
                    };
                    let RequiredDomicilio = function () {
                        return $("input[name='tipo_envio']").val() === Globals.PEDIDO_TIPO_ENVIO_DOMICILIO;
                    };

                    __handleForm(
                        'fPedido', {
                            rules: {
                                cod_direccion: {
                                    required: RequiredHabitual
                                },
                                nombre       : {
                                    required: RequiredDomicilio
                                },
                                nif          : {
                                    required: RequiredDomicilio
                                },
                                direccion    : {
                                    required: RequiredDomicilio
                                },
                                poblacion    : {
                                    required: RequiredDomicilio
                                },
                                provincia    : {
                                    required: RequiredDomicilio
                                },
                                cp           : {
                                    required : RequiredDomicilio,
                                    number   : true,
                                    minlength: 5,
                                    maxlength: 5
                                },
                                telefono     : {
                                    required : RequiredDomicilio,
                                    number   : true,
                                    minlength: 9,
                                    maxlength: 9
                                },
                                email        : {
                                    email: true
                                }
                            }
                        },
                        function ($form, json) {
                            let msg = "";
                            let status = "";
                            let redir = false;
                            if (json.success) {
                                msg = json.msg || "Se ha guardado correctamente el pedido";
                                status = "success";
                                // redir = json.redir ? parseInt(json.id) : false;
                                if (json.redir) {
                                    setTimeout(
                                        function () {
                                            location.href = HOST + "/pedidos/" + json.id_pedido;
                                        }, 1500
                                    )
                                }
                            } else {
                                if (json.error == 'cambios_precios') {
                                    let html = '';
                                    $.each(json.cambios, function (index, elem) {
                                        html += '<li>' +
                                            '<i uk-icon="icon: chevron-right"></i> <strong>' + elem.codigo + '</strong> ' +
                                            ' Antes: ' + elem.precio_antes + '&euro;' +
                                            ' Ahora: ' + elem.precio_nuevo + '&euro;' +
                                            '</li>'
                                    });
                                    $("ul", $("div#alert-cambios-precios")).html(html);
                                    $("div#alert-cambios-precios").fadeIn();
                                }
                                msg = json.msg || "Ha ocurrido un error a la hora de guardar el pedido";
                                status = "danger";
                            }
                            Notificacion(msg, status);
                        }
                    )
                } else if (type === TYPE_PRESUPUESTOS) {

                    $("#delete-presupuesto").off().on("click", function (e) {
                        e.preventDefault();
                        deletePresupuesto();
                    })
                    $("#accept-presupuesto").off().on('click', function (e) {
                        e.preventDefault();
                        $("input[name='id_estado']").val(Globals.PRESUPUESTO_ESTADO_ACEPTADO);
                        $("#fPresupuesto-save").trigger('click');
                    });
                    $("#reject-presupuesto").off().on('click', function (e) {
                        e.preventDefault();
                        $("input[name='id_estado']").val(Globals.PRESUPUESTO_ESTADO_RECHAZADO);
                        $("#fPresupuesto-save").trigger('click');
                    });


                    __handleForm(
                        'fPresupuesto', {
                            rules: {
                                nombre: {
                                    required: true
                                }
                            }
                        },
                        function ($form, json) {
                            let msg = "";
                            let status = "";
                            let redir = false;
                            if (json.success) {
                                msg = json.msg || "Se ha guardado correctamente el presupuesto";
                                status = "success";
                                // redir = json.redir ? parseInt(json.id) : false;
                                if (json.redir) {
                                    setTimeout(
                                        function () {
                                            location.href = HOST + '/presupuestos/' + json.id_presupuesto;
                                        }, 1500
                                    )
                                }
                            } else {
                                msg = json.msg || "Ha ocurrido un error a la hora de guardar el presupuesto";
                                status = "danger";
                            }
                            Notificacion(msg, status);
                        }
                    )
                }
            };

            if ($("#pedido-item").length > 0 || $("#presupuesto-item").length > 0) {
                LoadPreciosNetos();
                HandleActionsProductos();
                HandleForm();
            }

            $(".del-presupuesto").off().on('click', function (e) {
                e.preventDefault();
                deletePresupuesto($(this).data('id'))
            });
            $('.select-presupuesto').off().on('click', function (e) {
                e.preventDefault();
                selectPresupuesto($(this).data('id'));
            });
        }
    };

    let FormatoPrecio = function (number) {
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        let decimals = 2;
        let dec_point = ",";
        let thousands_sep = ".";

        let n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                const k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }

    let __initDashboard = function () {
        if ($("#page-dashboard").length > 0) {
            let loadPendientes = function () {
                $.ajax({
                    type    : "GET",
                    url     : HOST + "/ultimosPendientes/5",
                    dataType: "json",
                    success : function (json) {
                        if (json.success) {
                            $("div#pendientes").html(json.html);
                        } else {
                            $("div#pendientes").html("No se han encontrado artículos pendientes");
                        }
                    }
                })
            }

            let loadFacturas = function () {
                $.ajax({
                    type    : "GET",
                    url     : HOST + "/facturasRecientes",
                    dataType: "json",
                    success : function (json) {
                        if (json.success) {
                            $("div#facturas").html(json.html);
                        } else {
                            $("div#facturas").html("No se han encontrado facturas recientes");
                        }
                    }
                })
            }

            loadPendientes();
            loadFacturas();
        }
    };

    let __initPendientes = function () {
        if ($("#page-pendientes").length > 0) {
            let loadPendientes = function () {
                $.ajax({
                    type      : "GET",
                    url       : HOST + "/get-pendientes",
                    dataType  : "json",
                    beforeSend: function () {
                        __blockUI({
                            msg: '<i uk-spinner="ratio: 0.8"></i> Cargando pendientes...'
                        });
                    },
                    complete  : function () {
                        __unblockUI();
                    },
                    success   : function (json) {
                        if (json.error == 'session_out') {
                            location.href = HOST;
                        } else {
                            if (json.success) {
                                $("tbody#pendientes").html(json.html);
                            } else {
                                $("tbody#pendientes").html("No se han encontrado artículos pendientes");
                            }
                        }
                    }
                })
            }

            loadPendientes();
        }
    };

    let __initAlbaranes = function () {

        if ($("#page-albaranes").length > 0) {

            $("select.select2").select2();

            let handleButtonsAlbaranes = function () {
                $("a.btnAnularAlbaran").off().on("click", function (e) {
                    e.preventDefault();
                    const codigo = $(this).data("codigo");
                    const linea = $(this).data("linea");
                    // __confirm("Se va a anular este consumo. ¿Continuar?", function () {
                    //     $.ajax({
                    //         type: "POST",
                    //         url: HOST + "/consumos/anular/" + codigo + "/" + linea,
                    //         dataType: "json",
                    //         beforeSend: function () {
                    //             __blockUI({
                    //                 msg: '<i uk-spinner="ratio: 0.8"></i> Anulando el consumo...'
                    //             });
                    //         },
                    //         complete: function () {
                    //             __unblockUI();
                    //         },
                    //         success: function (json) {
                    //             if (json.error == 'session_out') {
                    //                 location.href = HOST;
                    //             } else {
                    //                 let msg = ""
                    //                 let status = "";
                    //                 if (json.success) {
                    //                     loadAlbaranes();
                    //                     msg = "Se ha anulado el consumo correctamente"
                    //                     status = "success";
                    //                 } else {
                    //                     msg = json.msg || "Ha ocurrido un error al intentar anular el consumo";
                    //                     status = "danger";
                    //                 }
                    //                 Notificacion(msg, status)
                    //             }
                    //             handleButtonsAlbaranes();
                    //         },
                    //         error: function () {
                    //             Notificacion("Ha ocurrido un error al intentar anular el consumo", "danger")
                    //         }
                    //     })
                    // });
                    __confirm({
                        title      : 'Se va a anular este consumo. ¿Continuar',
                        callback_ok: function () {
                            $.ajax({
                                type      : "POST",
                                url       : HOST + "/consumos/anular/" + codigo + "/" + linea,
                                dataType  : "json",
                                beforeSend: function () {
                                    __blockUI({
                                        msg: '<i uk-spinner="ratio: 0.8"></i> Anulando el consumo...'
                                    });
                                },
                                complete  : function () {
                                    __unblockUI();
                                },
                                success   : function (json) {
                                    if (json.error == 'session_out') {
                                        location.href = HOST;
                                    } else {
                                        let msg = ""
                                        let status = "";
                                        if (json.success) {
                                            loadAlbaranes();
                                            msg = "Se ha anulado el consumo correctamente"
                                            status = "success";
                                        } else {
                                            msg = json.msg || "Ha ocurrido un error al intentar anular el consumo";
                                            status = "danger";
                                        }
                                        Notificacion(msg, status)
                                    }
                                    handleButtonsAlbaranes();
                                },
                                error     : function () {
                                    Notificacion("Ha ocurrido un error al intentar anular el consumo", "danger")
                                }
                            })
                        }
                    })
                });
            };

            const loadAlbaranes = function () {
                const familia = $("select[name='familia']").val();
                const marca = $("select[name='marca']").val();
                const fecha_desde = $("input[name='fecha_desde']").val();
                const fecha_hasta = $("input[name='fecha_hasta']").val();
                $.ajax({
                    type      : "GET",
                    url       : HOST + "/get-consumos/" + familia + "/" + marca + "/" + fecha_desde + "/" + fecha_hasta,
                    dataType  : "json",
                    beforeSend: function () {
                        __blockUI({
                            msg: '<i uk-spinner="ratio: 0.8"></i> Cargando consumos...'
                        });
                    },
                    complete  : function () {
                        __unblockUI();
                    },
                    success   : function (json) {
                        if (json.error == 'session_out') {
                            location.href = HOST;
                        } else {
                            if (json.success) {
                                $("tbody#albaranes").html(json.html);
                            } else {
                                $("tbody#albaranes").html("No se han encontrado consumos");
                            }
                        }
                        handleButtonsAlbaranes();
                    }
                })
            }

            loadAlbaranes();
            $("a#btnSearchAlbaranes").off().on("click", function () {
                loadAlbaranes();
            });
            $("input", $("#fSearchAlbaranes")).off().on("keyup", function (e) {
                if (e.keyCode === 13) {
                    loadAlbaranes();
                }
            });
        }
    };

    let __initFacturas = function () {
        if ($("#page-facturas").length > 0) {

            let handleEventsList = function () {
                $("[data-action='checkFactura']").off().on("click", function (e) {
                    e.preventDefault();
                    const codFactura = $(this).data("cod-factura");
                    const serFactura = $(this).data("ser-factura");
                    $.ajax({
                        type      : "post",
                        url       : HOST + "/facturas/check/" + codFactura + "/" + serFactura,
                        dataType  : "json",
                        beforeSend: function () {
                            __blockUI({
                                msg: '<i uk-spinner="ratio: 0.8"></i> Descargando factura...'
                            });
                        },
                        complete  : function () {
                            __unblockUI();
                        },
                        success   : function (json) {
                            if (json.success) {
                                location.href = HOST + "/facturas/download/" + codFactura + "/" + serFactura;
                            } else {
                                Notificacion(json.msg, 'danger')
                            }
                        }
                    });
                });
            };

            let loadFacturas = function () {
                let fecha_desde = $("input[name='fecha_desde']").val();
                let fecha_hasta = $("input[name='fecha_hasta']").val();
                $.ajax({
                    type      : "GET",
                    url       : HOST + "/get-facturas/" + fecha_desde + "/" + fecha_hasta,
                    dataType  : "json",
                    beforeSend: function () {
                        __blockUI({
                            msg: '<i uk-spinner="ratio: 0.8"></i> Cargando facturas...'
                        });
                    },
                    complete  : function () {
                        __unblockUI();
                    },
                    success   : function (json) {
                        if (json.error == 'session_out') {
                            location.href = HOST;
                        } else {
                            if (json.success) {
                                $("tbody#facturas").html(json.html);
                                handleEventsList();
                            } else {
                                $("tbody#facturas").html("No se han encontrado facturas");
                            }
                        }
                    }
                })
            }

            loadFacturas();
            $("a#btnSearchFacturas").off().on("click", function () {
                loadFacturas();
            });
            $("input", $("#fSearchFacturas")).off().on("keyup", function (e) {
                if (e.keyCode === 13) {
                    loadFacturas();
                }
            });


        }
    }

    let __initCuentaCorriente = function () {
        if ($("#page-cuentacorriente").length > 0) {
            let loadCuentaCorriente = function () {
                let fecha_desde = $("input[name='fecha_desde']").val();
                let fecha_hasta = $("input[name='fecha_hasta']").val();
                $.ajax({
                    type      : "GET",
                    url       : HOST + "/get-cuenta-corriente/" + fecha_desde + "/" + fecha_hasta,
                    dataType  : "json",
                    beforeSend: function () {
                        __blockUI({
                            msg: '<i uk-spinner="ratio: 0.8"></i> Cargando cuenta corriente...'
                        });
                    },
                    complete  : function () {
                        __unblockUI();
                    },
                    success   : function (json) {
                        if (json.error == 'session_out') {
                            location.href = HOST;
                        } else {
                            if (json.success) {
                                $("tbody#cuentaCorriente").html(json.html);
                            } else {
                                $("tbody#cuentaCorriente").html("No se han encontrado movimientos");
                            }
                        }
                    }
                })
            }

            loadCuentaCorriente();
            $("a#btnSearchCuentaCorriente").off().on("click", function () {
                loadCuentaCorriente();
            });
            $("input", $("#fSearchCuentaCorriente")).off().on("keyup", function (e) {
                if (e.keyCode === 13) {
                    loadCuentaCorriente();
                }
            });
        }
    };

    let __initCirculares = function () {
        if ($("#page-circulares").length > 0) {
            __handlePreciosStock();
        }
    };

    let __initTransportes = function () {
        let initTransportesList = function () {
            let $pageID = $("#page-transportes");

            $(".del-transporte", $pageID).off().on("click", function (e) {
                e.preventDefault();
                deleteTransporte($(this).data('id'), true);
            })

        };

        let initTransportesForm = function () {
            let $pageID = $("#transporte-item");
            let $form = $("#fTransporte");

            $("select.select2").select2(
                {
                    dropdownCssClass: "ex-select2-small-font",
                    selectionCssClass: "ex-select2-small-font",
                }
            );

            __handleForm(
                'fTransporte', {
                    rules: {
                        fecha            : {
                            required: true
                        },
                        descripcion      : {
                            required: true
                        },
                        num_documento    : {
                            required: true
                        },
                        tramo_horario    : {
                            required: true
                        },
                        importe          : {
                            required: function () {
                                return $("select[name='cobrar']").val() === '1';
                            },
                            min     : function () {
                                return $("select[name='cobrar']").val() === '1' ? 0.01 : 0;
                            },
                        },
                        unidades_usado   : {
                            required: function () {
                                return $("select[name='retirar_usado']").val() === '1';
                            },
                            min     : function () {
                                return $("select[name='retirar_usado']").val() === '1' ? 1 : 0;
                            },
                        },
                        id_lugar_emision : {
                            required: true
                        },
                        id_lugar_recogida: {
                            required: true
                        },
                        id_lugar_alejado : {
                            required: true
                        },
                        id_trabajo_1     : {
                            required: true
                        },
                        id_trabajo_2     : {
                            required: true
                        },
                        id_trabajo_3     : {
                            required: true
                        },
                        id_trabajo_4     : {
                            required: true
                        },
                        nombre           : {
                            required: true
                        },
                        direccion        : {
                            required: true
                        },
                        poblacion        : {
                            required: true
                        }
                    }
                },
                function ($form, json) {
                    let msg = "";
                    let status = "";
                    let redir = false;
                    if (json.success) {
                        msg = json.msg || "Se ha guardado correctamente la información del transporte.";
                        status = "success";
                        calcularServiciosTransporte();
                        if (json.redir) {
                            setTimeout(
                                function () {
                                    location.href = HOST + '/transportes/' + json.id;
                                }, 1500
                            )
                        } else {
                            if(json.fecha_modificado) {
                                $("input[id='fecha_modificado']", $form).val(json.fecha_modificado);
                            }
                            if(json.nombre_usuario_modificado) {
                                $("input[id='nombre_usuario_modificado']", $form).val(json.nombre_usuario_modificado);
                            }
                        }
                    } else {
                        msg = json.msg || "Ha ocurrido un error a la hora de guardar la información del transporte.";
                        status = "danger";
                    }
                    if (json.success) {
                        Notificacion(msg, status, json.redir ? 1500 : null);
                    } else {
                        Notificacion(msg, status, 11000, true);
                    }
                }
            )

            //Form
            $("#delete-transporte", $pageID).off().on("click", function (e) {
                e.preventDefault();
                deleteTransporte();
            })

            $("button#verDisponibilidad", $pageID).on("click", function () {
                verDisponibilidad();
            });

            $(".calcularServiciosTransporte", $form).on("change", function () {
                calcularServiciosTransporte();
            });

            let calcularServiciosTransporte = function () {
                let startAjaxTime = new Date().getTime();
                $.ajax({
                    type      : "POST",
                    url       : HOST + "/transportes/calcular-servicios",
                    dataType  : "json",
                    data      : {
                        id               : $("input[name='id']", $form).val(),
                        fecha            : $("input[name='fecha']", $form).val(),
                        tramo_horario    : $("select[name='tramo_horario']", $form).val(),
                        id_lugar_emision : $("select[name='id_lugar_emision']", $form).val(),
                        id_lugar_recogida: $("select[name='id_lugar_recogida']", $form).val(),
                        id_lugar_alejado : $("select[name='id_lugar_alejado']", $form).val(),
                        id_trabajo_1     : $("select[name='id_trabajo_1']", $form).val(),
                        id_trabajo_2     : $("select[name='id_trabajo_2']", $form).val(),
                        id_trabajo_3     : $("select[name='id_trabajo_3']", $form).val(),
                        id_trabajo_4     : $("select[name='id_trabajo_4']", $form).val()
                    },
                    beforeSend: function () {
                        $("div#blk-servicios-transporte", $form).html('<div class="uk-height-1-1 uk-background-muted ex-radius uk-flex uk-flex-middle"><h3 class="uk-width-1-1 uk-text-center"><i uk-spinner="ratio: 0.8"></i> Calculando servicios de transporte...</h3></div>');
                    },
                    success   : function (json) {
                        if (json.success) {
                            let endAjaxTime = new Date().getTime() - startAjaxTime;
                            // handleDatePicker(json.diasCerrados);
                            let timeoutValue = endAjaxTime > 200 ? 0 : 250;
                            setTimeout(function () {
                                $("div#blk-servicios-transporte", $form).html(json.html);
                            }, timeoutValue);
                        } else {
                            Notificacion("Ha ocurrido un error al intentar calcular los servicios del transporte", "danger");
                        }
                    }
                })
            };

            let verDisponibilidad = function () {
                $.ajax({
                    type      : "GET",
                    url       : HOST + "/transportes/ver-disponibilidad",
                    beforeSend: function () {
                        __blockUI();
                    },
                    complete  : function () {
                        __unblockUI();
                    },
                    success   : function (json) {
                        if (json.success) {
                            Swal.fire({
                                html: json.html,
                                customClass: 'swal-big'
                            })
                        }
                    },
                })
            }

            let handleDatePicker = function (diasCerrados = null) {
                let $fecha = $('input[name="fecha"]', $form);
                if (diasCerrados != null) {
                    $fecha.data('dias_cerrados', diasCerrados);

                    // se comenta porque ya solo se carga el datepicker una vez
                    // $fecha.datepicker("destroy");
                }
                let $diasCerrados = $fecha.data('dias_cerrados');

                $fecha.datepicker({
                    minDate      : "today",
                    beforeShowDay: function (date) {
                        //ocultamos los días cerrados

                        const yyyy = date.getFullYear();
                        let mm = date.getMonth() + 1;
                        let dd = date.getDate();

                        if (dd < 10) dd = '0' + dd;
                        if (mm < 10) mm = '0' + mm;

                        const formatedDate = yyyy + '-' + mm + '-' + dd;

                        if ($diasCerrados.includes(formatedDate)) {
                            return [false, '', ''];
                        } else {
                            return [true, '', ''];
                        }
                    }
                });
            }

            if ($.isFunction($.fn.datepicker)) {
                handleDatePicker();
            }
        };

        let deleteTransporte = function (id_transporte, $recargar_listado = false) {
            let id = typeof id_transporte !== 'undefined' ? id_transporte : $("input[name='id']", $("#fTransporte")).val();

            __confirm({
                title      : 'Se va a eliminar el transporte. ¿Continuar?',
                msg        : 'Una vez confirmado, no se podrá recuperar el transporte',
                callback_ok: function () {
                    $.ajax({
                        type    : "DELETE",
                        url     : HOST + "/transportes/del/" + id,
                        dataType: "json",
                        success : function (json) {
                            if (json.success) {
                                Notificacion("Se ha eliminado el transporte correctamente", "success", 1500);
                                setTimeout(function () {
                                    if ($recargar_listado) {
                                        $("#fSearchTransportes").submit();
                                    } else {
                                        location.href = HOST + "/transportes";
                                    }
                                }, 1500);
                            } else {
                                Notificacion("Ha ocurrido un error al intentar eliminar el transporte", "danger");
                            }
                        }
                    });
                }
            })
        };

        initTransportesList();
        initTransportesForm();
    };

    let __initBloqueo = function () {
        let $bloqueoBtn = $("[data-action='bloqueo_precios']");
        if ($bloqueoBtn.length > 0) {
            $bloqueoBtn.off().on("click", function () {
                $.ajax({
                    type      : "GET",
                    url       : HOST + "/bloqueo-precios",
                    dataType  : "json",
                    beforeSend: function () {
                        __blockUI();
                    },
                    complete  : function () {
                        __unblockUI();
                    },
                    success   : function (json) {
                        if (json.error == 'session_out') {
                            location.href = HOST;
                        } else {
                            if (json.success) {
                                location.reload();
                            }
                        }
                    }
                });
            });
        }
    };

    let __initSugerencias = function () {
        let HandleForm = function () {
            let $form = $("#fSugerencia");
            let $formSearch = $("#fSearchComentarios");

            $("#btnSearchSugerencias", $formSearch).off().on("click", function (e) {
                e.preventDefault();
                $formSearch.submit();
            });
            /*tinymce.init({
                selector: "textarea[name='contenido']",
                language: "es"
            });*/
            let toolbar = 'formatselect | bold italic underline strikethrough | codesample blockquote | bullist numlist | outdent indent pre | link | code';
            let plugins = 'link lists codesample code';

            $("textarea[name='contenido']").tinymce({
                language      : 'es',
                script_url    : HOST + '/assets/plugins/tinymce/js/tinymce/tinymce.min.js',
                menubar       : false,
                min_height    : 200,
                toolbar       : toolbar,
                plugins       : plugins,
                keep_styles   : false,
                statusbar     : false,
                valid_elements: 'a[href|target=_blank],strong/b,u,em/i,div,p,br,ul,li,ol,blockquote,pre,code,h1,h2,h3,h4,h5,h6'
            });

            $("textarea[name='contenido_comentario']").tinymce({
                language      : 'es',
                script_url    : HOST + '/assets/plugins/tinymce/js/tinymce/tinymce.min.js',
                menubar       : false,
                min_height    : 200,
                toolbar       : toolbar,
                plugins       : plugins,
                keep_styles   : false,
                statusbar     : false,
                valid_elements: 'a[href|target=_blank],strong/b,u,em/i,div,p,br,ul,li,ol,blockquote,pre,code,h1,h2,h3,h4,h5,h6'
            });

            $("#send-sugerencia").off().on("click", function (e) {
                e.preventDefault();
                tinymce.triggerSave();
                $form.submit();
            });

            __handleForm(
                'fSugerencia', {
                    rules: {
                        asunto   : {
                            required: true
                        },
                        contenido: {
                            required: true
                        }
                    }
                },
                function ($form, json) {
                    let msg = "";
                    let status = "";
                    let redir = false;
                    if (json.success) {
                        msg = json.msg || "Se ha enviado correctamente su comentario";
                        status = "success";
                        // redir = json.redir ? parseInt(json.id) : false;
                        if (json.redir) {
                            setTimeout(
                                function () {
                                    location.href = HOST + "/comentarios";
                                }, 500
                            )
                        }
                        Notificacion(msg, status);
                    } else {
                        msg = json.msg || "Ha ocurrido un error a la hora de enviar su comentario";
                        status = "danger";
                    }
                }
            )

        };

        let HandleFormComentario = function () {
            let $form = $("#fComentario");

            $("#send-comentario").off().on("click", function (e) {
                e.preventDefault();
                $form.submit();
            });

            __handleForm(
                'fComentario', {
                    rules: {
                        contenido_comentario: {
                            required: true
                        }
                    }
                },
                function ($form, json) {
                    let msg = "";
                    let status = "";
                    let redir = false;
                    if (json.success) {
                        msg = json.msg || "Se ha enviado correctamente su comentario";
                        status = "success";
                        // redir = json.redir ? parseInt(json.id) : false;
                        if (json.redir) {
                            setTimeout(
                                function () {
                                    location.href = HOST + "/comentarios/" + json.id_sugerencia;
                                }, 500
                            )
                        }
                        Notificacion(msg, status);
                    } else {
                        msg = json.msg || "Ha ocurrido un error a la hora de enviar su comentario";
                        status = "danger";
                    }
                }
            )
        };

        if ($("#page-sugerencias").length > 0) {
            HandleForm();
        }
        if ($("#sugerencia-item").length > 0) {
            HandleFormComentario();
        }
    };

    let number_format = function (number, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        let n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                const k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    };

    let __initGeolocation = function () {
        const glocation = Cookies.get('glocation');
        if (navigator.geolocation) {
            if (glocation === "1") {
                navigator.geolocation.getCurrentPosition(function (objPosition) {
                    guardaGeolocalizacion(objPosition.coords.longitude, objPosition.coords.latitude);
                }, function (objPositionError) {
                    rechazaGeolocalizacion(objPositionError.code, objPositionError.message);
                    // console.log("ERROR: " + objPositionError.code + " - " + objPositionError.message);
                });
                // showMsgUbicacionRequerida(() => location.reload());
            }
        } else {
            rechazaGeolocalizacion(0, "El navegador no soporta geolocalización");
            // console.log("No soportado API de geolocalización")
        }

        //Para comprobar la geolocalización, comprobamos si no tiene la cookie establecida (si ya aceptó o rechazó), y en caso de que no la tenga, hacemos llamada Ajax para comprobar que el cliente que está conectado tiene marcada la opción de geolocalización
        // const glocation = Cookies.get('glocation');
        // if (glocation !== "1") {
        //     //Comprobamos, vía Ajax, si hay que solicitarle la ubicación
        //     $.ajax({
        //         type: "GET",
        //         url: HOST + "/geolocalizacion",
        //         dataType: "json",
        //         success: function (data) {
        //             if (data.success) {
        //                 if (data.requiereGeolocalizacion) {

        //                 }
        //             }
        //         }
        //     });
        // }
    };

    function guardaGeolocalizacion(longitud, latitud) {
        $.ajax({
            type    : "POST",
            url     : HOST + "/geolocalizacion/aceptar",
            dataType: "json",
            data    : {
                lat : latitud,
                long: longitud
            }
        });
    }

    function rechazaGeolocalizacion(errorCode, mensaje) {
        $.ajax({
            type    : "POST",
            url     : HOST + "/geolocalizacion/rechazar",
            dataType: "json",
            data    : {
                code: errorCode,
                msg : mensaje
            },
            success : function (json) {
                if (json.success) {
                    showMsgUbicacionRequerida(() => location.href = HOST + "/logout");
                }
            }
        });
    }

    const showMsgUbicacionRequerida = function (callback) {
        const msg = '' +
            '<p>Para utilizar la intranet, es necesario conceder permisos de ubicación.<br>Podrás ver como hacerlo según el navegador en los siguientes enlaces:</p>' +
            '<ul class="uk-list">' +
            '<li><a href="https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DDesktop&hl=es" target="_blank">Google Chrome</a>' +
            '<li><a href="https://support.microsoft.com/es-ve/help/4536154/microsoft-edge-location-and-privacy" target="_blank">Microsoft Edge</a>' +
            '<li><a href="https://support.mozilla.org/es/kb/firefox-comparte-mi-ubicacion-con-sitios-web" target="_blank">Mozilla Firefox</a>' +
            '<li><a href="https://support.apple.com/es-es/HT5403" target="_blank">Apple Safari</a>' +
            '</ul>';
        __alert({
            msg: msg
        }, function () {
            callback.call();
        })
    };

    const handleUpload = function (id_parent, opts) {
        opts = opts || {};
        opts.type = opts.type || 'file';
        opts.pageID = opts.pageID || '';
        opts.aux = opts.aux || '';
        opts.key = typeof opts.key !== "undefined" ? opts.key : '';
        switch (opts.type) {
            case 'file':
                opts.acceptedFiles = opts.acceptedFiles || 'audio/*,image/*,.psd,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar';
                opts.dictDefaultMessage = opts.dictDefaultMessage || '<i class="icon icon-cloud-upload"></i> Arrastre archivos a esta zona<br />o pulse para añadir documentos';
                break;
            case 'img':
                opts.acceptedFiles = opts.acceptedFiles || '.jpeg,.jpg,.png,.gif,.JPEG,.JPG,.PNG,.GIF';
                opts.dictDefaultMessage = opts.dictDefaultMessage || '<i class="icon icon-cloud-upload"></i> Arrastre archivos a esta zona<br />o pulse para añadir imágenes';
                break;
        }

        switch (opts.type) {
            default:
                const formId = opts.pageID + '_' + id_parent;
                const container = formId + '_' + opts.type;
                const previewsContainer = container + ' .dropzone-previews';
                const $container = $(previewsContainer).closest('.portlet');
                break;
        }

        // console.log(formId);
        // console.log(container);

        $container.off('click', '.stdFileAction').on('click', '.stdFileAction', function (e) {
            switch ($(this).data('action')) {
                case 'new':
                    e.preventDefault();

                    switch (opts.type) {
                        case 'file':
                        case 'img':
                            $container.find('.dropzone').trigger('click');
                            break;
                    }

                    break;
            }
        });

        opts = $.extend(true, {
            url                         : opts.url,
            dictDefaultMessage          : '<i class="icon icon-cloud-upload"></i> Arrastre archivos a esta zona<br />o pulse para añadir documentos',
            dictFallbackMessage         : 'Su navegador no soporta arrastrar y soltar para la carga de archivos',
            dictFallbackText            : 'Utilice el formulario de abajo para subir sus archivos',
            dictFileTooBig              : 'El archivo es demasiado grande ({{filesize}}MB). Máx: {{maxFilesize}}MB.',
            dictInvalidFileType         : 'No se puede cargar archivos de este tipo',
            dictResponseError           : 'El servidor respondió con el código <strong>{{statusCode}}</strong>',
            dictCancelUpload            : 'Cancelar',
            dictCancelUploadConfirmation: '¿Está seguro que desea cancelar la subida?',
            dictRemoveFile              : 'Eliminar',
            dictMaxFilesExceeded        : 'No puede subir más ficheros',
            dictRemoveFileConfirmation  : null,
            thumbnailWidth              : 64,
            thumbnailHeight             : 64,
            previewsContainer           : previewsContainer,
            previewTemplate             : templates.preview,
            addRemoveLinks              : true,
            maxFilesize                 : 1000, // MB
            params                      : {
                type     : opts.type,
                id_parent: id_parent,
                aux      : opts.aux
            },
            init                        : function () {
                this.on("addedfile", function (file) {
                    const $dz_remove = $(file.previewElement).find('.dz-remove');
                    $(file.previewElement).find('.filetype').toggleClass('filetype-' + file.name.split('.').pop(), true);
                    $dz_remove
                        .attr('data-action', 'del')
                        .toggleClass('dz-remove', false)
                        .toggleClass('btn', true)
                        .toggleClass('default', true)
                        .toggleClass('btn-xs', true)
                        .toggleClass('red-thunderbird-stripe', true)
                        .appendTo($(file.previewElement).find('.file-actions'));
                });
                this.on("processing", function (file) {
                    $(file.previewElement).find('.btn[data-action="del"]').html('<i class="fa fa-times"></i> Cancelar');
                });
                this.on("success", function (file, responseText) {
                    try {
                        const json = responseText;
                        if (json.success) {
                            let output = '';
                            let $output = null;
                            if (json.fileinfo) {
                                switch (opts.type) {
                                    case "image":
                                        output = templates.image.render(json.fileinfo);
                                        break;
                                    default:
                                        output = templates.file.render(json.fileinfo);
                                        $(output).find('a[data-action="star"]').remove();
                                        $(output).find('a[data-action="edit"]').remove();
                                        break;
                                }

                                $output = $(output);
                            }
                            $(file.previewElement).replaceWith($output);

                            if (opts.type == 'file') {
                                $output.find('a[data-action="star"]').remove();
                            }
                            $output.find('a[data-action="del"]').remove();


                        } else {

                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
                this.on("error", function (file, errorMessage, xhrRequest) {
                    $(".pie-progress-wrapper", file.previewElement).hide();
                    $(".text-danger", file.previewElement).show();
                });
                this.on("uploadprogress", function (file, progress) {
                    $uploadProgressWrapper = $(file.previewElement).find('.pie-progress-wrapper');
                    $uploadProgress = $uploadProgressWrapper.find('.pie-progress');
                    $spinner = $uploadProgress.find('.spinner');
                    $filler = $uploadProgress.find('.filler');
                    $mask = $uploadProgress.find('.mask');

                    filler_opactity = 0;
                    mask_opactity = 1;

                    degree = parseInt(progress * 3.6, 10);

                    if (progress > 50) {
                        filler_opactity = 1;
                        mask_opactity = 0;
                    }

                    $spinner.css({
                        '-webkit-transform': 'rotate(' + degree + 'deg)',
                        '-moz-transform'   : 'rotate(' + degree + 'deg)',
                        '-ms-transform'    : 'rotate(' + degree + 'deg)',
                        '-o-transform'     : 'rotate(' + degree + 'deg)',
                        'transform'        : 'rotate(' + degree + 'deg)'
                    });
                    $filler.css({opacity: filler_opactity});
                    $mask.css({opacity: mask_opactity});
                });
            }
        }, opts);

        if (opts.type != 'link') {
            // console.log($(".dropzone", container));
            $(".dropzone", container).dropzone(opts);
        }

    };

    const __initMiCuenta = function () {
        if ($("#page-micuenta").length > 0) {
            const loadModalChangePwd = function () {
                UIkit.modal("#modalChangePwd").show();
            };

            const $formChgPwd = $("#fChgPwd")
            $formChgPwd.validate({
                rules        : {
                    clave_actual  : {
                        required: true
                    },
                    clave_nueva   : {
                        required: true,
                        equalTo : '#clave_nueva_re'
                    },
                    clave_nueva_re: {
                        required: true,
                        equalTo : '#clave_nueva'
                    }
                },
                messages     : {
                    clave_nueva   : {
                        equalTo: 'Las contraseñas no coinciden'
                    },
                    clave_nueva_re: {
                        equalTo: 'Las contraseñas no coinciden'
                    }
                },
                submitHandler: function (form) {
                    $(form).ajaxSubmit({
                        dataType  : "json",
                        error     : App.handleError,
                        beforeSend: function () {
                            __blockUI({
                                msg: '<i uk-spinner="ratio: 0.8"></i> Cambiando la contraseña...'
                            });
                        },
                        complete  : function () {
                            __unblockUI();
                        },
                        success   : function (json) {
                            __unblockUI();
                            let msg = '';
                            let status = '';
                            if (json.success) {
                                status = 'success';
                                msg = 'Se ha cambiado la contraseña correctamente';

                                setTimeout(function () {
                                    $("input", $formChgPwd).val("");
                                    UIkit.modal('#modalChangePwd').hide();
                                }, 2000);
                            } else {
                                msg = json.msg ?? 'Ha ocurrido un error al cambiar la contraseña';
                                status = "danger";
                            }
                            Notificacion(msg, status);
                        }
                    })
                }
            });

            $('div.uk-card', $("div.menu-mi-cuenta")).on('click', function () {
                location.href = $(this).data('href');
            });

            $(".btnChangePwd").off().on('click', function (e) {
                e.preventDefault();
                loadModalChangePwd();
            });
            $(".btnSavePwd").off().on('click', function (e) {
                e.preventDefault();
                $formChgPwd.submit();
            });
        }
    };

    const __handleDropzoneAccount = function (id) {
        const previewsContainer = '#avatar-imgs';
        let previewsHTML = $(previewsContainer).html();

        $('.del-image').on('click', function (e) {
            e.preventDefault();

            modalConfirm('<p>' + App.texts.txt_img_elim_p + '</p>', function () {
                    $.ajax({
                        type    : "post",
                        url     : HOST + '/mi-cuenta/delete-image',
                        dataType: "json",
                        success : function (json) {
                            if (json.success) {
                                Notificacion(App.texts.txt_img_elim,
                                    'success');
                                $(previewsContainer).html('<div class="dz-preview-container">\n\t<div class="dz-preview dz-file-preview">\n\t\t<div class="ok-avatar-img">\n\t\t\t<div class="dz-image">\n\t\t\t\t<img src="' + HOST + '/assets/img/avatar.png">\n\t\t\t</div>\n\t\t\t</div>\n\t</div>\n</div>');
                                $('.del-image').fadeOut('normal', function () {
                                })
                            } else {
                                if (json.session_error) {
                                    __alert(json.msg, function () {
                                        location.reload();
                                    });
                                    return;
                                }
                                if (typeof json.msg != undefined) {
                                    Notificacion(json.msg,
                                        'danger');
                                }
                            }
                        },
                    });
                }
            )
        })

        $("#avatar-upload").dropzone({
            url                         : HOST + '/mi-cuenta/upload',
            clickable                   : '#avatar-upload > *',
            dictDefaultMessage          : '<i class="icon icon-cloud-upload"></i> ' + App.texts.txt_img_arrastra,
            dictFallbackMessage         : App.texts.txt_img_navegador,
            dictFallbackText            : App.texts.txt_img_form,
            dictFileTooBig              : App.texts.txt_img_grande,
            dictInvalidFileType         : App.texts.txt_img_tipo,
            dictResponseError           : App.texts.txt_img_servidor,
            dictCancelUpload            : App.texts.txt_cancelar,
            dictCancelUploadConfirmation: App.texts.txt_img_cancelar_p,
            dictRemoveFile              : App.texts.txt_eliminar,
            dictMaxFilesExceeded        : App.texts.txt_img_superado,
            dictRemoveFileConfirmation  : null,
            acceptedFiles               : 'image/*',
            thumbnailWidth              : 200,
            thumbnailHeight             : 200,
            previewsContainer           : previewsContainer,
            previewTemplate             : '<div class="dz-preview-container">\n\t<div class="dz-preview dz-file-preview">\n\t\t<div class="ok-avatar-img">\n\t\t\t<div class="dz-image">\n\t\t\t\t<img data-dz-thumbnail/>\n\t\t\t</div>\n' + HOST + '\t\t\t\n\t\t\t<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n\t\t\t<div class="dz-error-message"><span data-dz-errormessage></span></div>\n\t\t\t<div class="dz-success-mark">\n\t\t\t\t<i class="uk-icon-check"></i>\n\t\t\t</div>\n\t\t\t<div class="dz-error-mark">\n\t\t\t\t<i class="uk-icon-times"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>',
            addRemoveLinks              : false,
            maxFilesize                 : 5, // MB,
            maxFiles                    : 1,
            init                        : function () {
                const th = this;

                this.on("addedfile", function (file) {
                    $(previewsContainer).children(':eq(0)').remove();
                });
                this.on("processing", function (file) {

                });
                this.on("success", function (file, responseText) {
                    try {
                        const json = responseText;
                        if (json.success) {
                            let output = '';
                            let $output = null;
                            let img = '';
                            if (json.fileinfo) {
                                output = Hogan.compile(
                                    '<div class="dz-preview-container">\n\t<div class="dz-preview dz-file-preview">\n\t\t<div class="ok-avatar-img">\n\t\t\t<div class="dz-image">\n\t\t\t\t<img src="{{media_url}}"/>\n\t\t\t</div>\n\t\t\t<i><img src="' + HOST + '/assets/svg/icon-lock.svg" alt="Editar" width="25"></i>\n\t\t</div>\n\t</div>\n</div>\n\n\n').render(json.fileinfo);
                                $output = $(output);
                                img = json.fileinfo.media_url;
                            } else {
                                img = HOST + '/assets/img/avatar.png';
                            }
                            previewsHTML = output;
                            $(previewsContainer).html(output);
                            $('.del-image').fadeIn('normal', function () {
                            })
                        } else {
                            if (json.session_error) {
                                __alert(json.msg, function () {
                                    location.reload();
                                });
                                return;
                            }
                            $(previewsContainer).html('<div class="dz-preview-container">\n\t<div class="dz-preview dz-file-preview">\n\t\t<div class="ok-avatar-img">\n\t\t\t<div class="dz-image">\n\t\t\t\t<img src="' + HOST + '/assets/img/avatar.png">\n\t\t\t</div>\n\t\t\t<i><img src="' + HOST + '/assets/svg/icon-lock.svg" alt="Editar" width="25"></i>\n\t\t</div>\n\t</div>\n</div>');
                            __alert(App.texts.txt_img_err);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
                this.on("error", function (file, errorMessage, xhrRequest) {
                    __alert(errorMessage);
                });
                this.on('queuecomplete', function () {
                    try {
                        th.removeAllFiles();
                    } catch (err) {
                    }
                })
            }
        });
    };


    const modalConfirm = function (message, onConfirm, onCancel, buttons) {
        if (typeof buttons == "undefined") {
            buttons = {
                ok: 'Continuar', cancel: 'Cancel' +
                    'ar'
            };
        }
        UIkit.modal.confirm(message,
            {
                labels: buttons
            }).then(
            function () {
                if (typeof (onConfirm) == 'function') {
                    onConfirm.call(null);
                }
            },
            function () {
                if (typeof (onCancel) == 'function') {
                    onCancel.call(null);
                }
            }
        );
    };

    return {
        init : function () {
            __initRenewSession();

            __initFastClick();
            __initGcvComisiones();
            __initValidation();
            __initInputs();
            __initDates();
            __initCookiePolicy();
            __initLogin();
            __initProductos();
            __initProducto();
            __initComparador();
            __initFastSearch();
            __initChainSelects();
            __initMargenes();
            __initMargen();
            __initBloqueo();

            __initPedidoPresupuesto();

            __initDashboard();
            __initPendientes();
            __initAlbaranes();
            __initFacturas();
            __initCuentaCorriente();
            __initCirculares();
            __initTransportes();
            __initSugerencias();

            __initMiCuenta();
            __handleDropzoneAccount();
            __initGeolocation();

            __handleDesgloseDescuentos();
        },
        texts: {
            txt_favoritos_ok      : '<i class="uk-icon-check"></i> Operación guardada como favorita',
            txt_favoritos_ko      : '<i class="uk-icon-check"></i> Operación eliminada de sus favoritos',
            txt_favorito_marcar   : 'Marcar como favorito',
            txt_favorito_desmarcar: 'Eliminar de favoritos',
            txt_cookies           : "Utilizamos cookies propias y de terceros para mejorar nuestros servicios y poder ofrecerle las mejores opciones mediante el análisis de la navegación.",
            txt_cookies_btn       : "Aceptar",
            txt_cookies_info      : "Más información",
            txt_img_elim          : "Imagen eliminada correctamente",
            txt_img_elim_p        : "¿Estás seguro de eliminar la imagen?",
            txt_img_arrastra      : "Arrastra una imagen o haz click para editar",
            txt_img_navegador     : "Su navegador no soporta arrastrar y soltar para la carga de archivos",
            txt_img_form          : "Utilice el formulario de abajo para subir sus archivos",
            txt_img_grande        : "El archivo es demasiado grande ({{filesize}}MB). Máx: {{maxFilesize}}MB.",
            txt_img_tipo          : "No se puede cargar archivos de este tipo",
            txt_img_servidor      : "El servidor respondió con el código <strong>{{statusCode}}</strong>",
            txt_img_cancelar_p    : "¿Está seguro que desea cancelar la subida?",
            txt_img_superado      : "No puede subir más de {{maxFiles}} fichero",
            txt_img_err           : "Ha ocurrido un error al subir la imagen",
            txt_cancelar          : "Cancelar",
            txt_eliminar          : "Eliminar"
        }
    };
}();

$(function () {
    App.init();
});